<template>
  <div fluid class="pa-0 fill-height d-flex flex-column">
    <!-- Top Toolbar -->
    <v-app-bar width="100%" flat color="#1E1E1E" dark class="border-bottom px-4 pt-2 d-flex justify-center" height="auto">
      <v-row align="center" no-gutters>
        <!-- Desktop View -->
        <v-col class="d-none d-md-flex align-center justify-center">
          <div class="d-flex align-center mr-3">
            <v-select
              dense
              outlined
              hide-details
              v-if="userService.hasRight('todo_changeStudio')"
              dark
              :items="studios"
              v-model="selectedStudio"
              item-text="name"
              item-value="_id"
              @change="reloadTodos"
              label="Studio"
              style="width: 150px"
              class="mr-2"></v-select>

            <v-switch
              v-if="showAllStudioSelect"
              label="Alle Studios"
              v-model="showAllStudios"
              hide-details
              dense
              dark
              v-bind="attrs"
              v-on="on"
              @change="reloadTodos"></v-switch>
          </div>

          <div class="mr-3" style="width: 200px">
            <v-autocomplete
              v-model="selectedUserFilter"
              :items="availableUsersForFilter"
              item-text="fullname"
              item-value="_id"
              return-object
              label="User Filter"
              dense
              outlined
              dark
              hide-details
              clearable>
              <template v-slot:item="{ item }">
                <v-avatar size="24" class="mr-2" color="grey darken-3">
                  <span class="white--text caption">{{ item.vorname[0] }}{{ item.nachname[0] }}</span>
                </v-avatar>
                {{ item.fullname }}
              </template>
              <template v-slot:selection="{ item }"> {{ item.vorname }} {{ item.nachname }} </template>
            </v-autocomplete>
          </div>

          <v-menu offset-y dark>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="mr-1"><v-icon>mdi-sort</v-icon></v-btn>
            </template>
            <v-list dense dark color="#1E1E1E">
              <v-list-item @click="setSort('priority')">
                <v-list-item-title :class="{ 'font-weight-bold': sortBy === 'priority' }">Priorität</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setSort('date')">
                <v-list-item-title :class="{ 'font-weight-bold': sortBy === 'date' }">Datum</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y dark>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="mr-3"
                ><v-icon>{{ viewIcon }}</v-icon></v-btn
              >
            </template>
            <v-list dense dark color="#1E1E1E">
              <v-list-item @click="viewMode = 'list'"
                ><v-list-item-icon><v-icon>mdi-view-list</v-icon></v-list-item-icon
                ><v-list-item-title>Liste</v-list-item-title></v-list-item
              >
              <v-list-item @click="viewMode = 'board'"
                ><v-list-item-icon><v-icon>mdi-developer-board</v-icon></v-list-item-icon
                ><v-list-item-title>Board</v-list-item-title></v-list-item
              >
              <v-list-item @click="viewMode = 'timeline'"
                ><v-list-item-icon><v-icon>mdi-timeline-clock</v-icon></v-list-item-icon
                ><v-list-item-title>Zeitstrahl</v-list-item-title></v-list-item
              >
            </v-list>
          </v-menu>

          <v-btn color="primary" @click="openCreateDialog" elevation="0" small> <v-icon left small>mdi-plus</v-icon> Neu </v-btn>
          <v-btn v-if="activeTab === 'redaktionsplan'" color="pink" dark outlined @click="marketingEventDialog = true" class="ml-3" small>
            <v-icon left small>mdi-calendar-star</v-icon> Kampagnen-Tage
          </v-btn>
        </v-col>

        <!-- Mobile View -->
        <v-col class="d-flex d-md-none align-center justify-space-between my-5" cols="12">
          <v-btn color="primary" @click="openCreateDialog" elevation="0"> <v-icon left>mdi-plus</v-icon> Neu </v-btn>

          <v-menu offset-y :close-on-content-click="false" dark left min-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on"> Filter <v-icon>mdi-filter-variant</v-icon> </v-btn>
            </template>
            <v-card class="pa-4" color="#1E1E1E">
              <div class="text-subtitle-2 mb-2 grey--text">Filter & Optionen</div>

              <div class="mb-3">
                <v-select
                  v-if="userService.hasRight('todo_changeStudio')"
                  dense
                  outlined
                  hide-details
                  dark
                  :items="studios"
                  v-model="selectedStudio"
                  item-text="name"
                  item-value="_id"
                  @change="reloadTodos"
                  label="Studio"></v-select>
                <v-switch
                  v-if="showAllStudioSelect"
                  v-model="showAllStudios"
                  label="Alle Studios"
                  dense
                  hide-details
                  class="mt-2"
                  dark
                  @change="reloadTodos"></v-switch>
              </div>

              <div class="mb-3">
                <v-autocomplete
                  v-model="selectedUserFilter"
                  :items="availableUsersForFilter"
                  item-text="fullname"
                  item-value="_id"
                  return-object
                  label="User Filter"
                  dense
                  outlined
                  dark
                  hide-details
                  clearable>
                  <template v-slot:item="{ item }">
                    <v-avatar size="24" class="mr-2" color="grey darken-3">
                      <span class="white--text caption">{{ item.vorname[0] }}{{ item.nachname[0] }}</span>
                    </v-avatar>
                    {{ item.fullname }}
                  </template>
                  <template v-slot:selection="{ item }"> {{ item.vorname }} {{ item.nachname }} </template>
                </v-autocomplete>
              </div>

              <div class="d-flex align-center justify-space-between mb-3">
                <v-chip
                  v-if="userService.hasRight('todo_fetchAndEdit')"
                  filter
                  :input-value="onlyUserTodos"
                  @click="toggleOnlyUserTodos"
                  color="primary"
                  outlined
                  dark>
                  <v-icon left>mdi-account</v-icon> Meine ToDos
                </v-chip>
              </div>

              <v-divider class="mb-3"></v-divider>

              <div class="d-flex justify-space-between">
                <v-menu offset-y dark>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text small v-bind="attrs" v-on="on"><v-icon left>mdi-sort</v-icon> Sortieren</v-btn>
                  </template>
                  <v-list dense dark color="#1E1E1E">
                    <v-list-item @click="setSort('priority')">
                      <v-list-item-title>Priorität</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setSort('date')">
                      <v-list-item-title>Datum</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-menu offset-y dark>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text small v-bind="attrs" v-on="on"
                      ><v-icon left>{{ viewIcon }}</v-icon> Ansicht</v-btn
                    >
                  </template>
                  <v-list dense dark color="#1E1E1E">
                    <v-list-item @click="viewMode = 'list'"><v-list-item-title>Liste</v-list-item-title></v-list-item>
                    <v-list-item @click="viewMode = 'board'"><v-list-item-title>Board</v-list-item-title></v-list-item>
                    <v-list-item @click="viewMode = 'timeline'"><v-list-item-title>Zeitstrahl</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
    </v-app-bar>

    <!-- Tabs & Content -->
    <div fluid class="flex-grow-1 overflow-y-auto pa-4">
      <v-tabs centered v-model="activeTab" background-color="transparent" dark color="primary" class="mb-4 rounded-lg">
        <v-tab href="#techniker" class="text-capitalize">Techniker</v-tab>
        <v-tab href="#marketing" class="text-capitalize">Marketing</v-tab>
        <v-tab v-if="userService.hasRight('coo_toDoListItems')" href="#coo" class="text-capitalize">COO</v-tab>
        <v-tab v-if="userService.hasRight('cl_toDoListItems')" href="#cl" class="text-capitalize">CL</v-tab>
        <v-tab v-if="userService.hasRight('it_toDoListItems')" href="#it" class="text-capitalize">IT</v-tab>
        <v-tab v-if="userService.hasRight('marketing_redactionToDos')" href="#redaktionsplan" class="text-capitalize">Redaktionsplan</v-tab>
        <v-tab href="#resolved" class="text-capitalize">Erledigt</v-tab>
      </v-tabs>

      <v-tabs-items touchless v-model="activeTab" style="background-color: transparent" dark>
        <!-- Generic Tab Content Generator -->
        <v-tab-item v-for="category in ['techniker', 'marketing', 'coo', 'cl', 'it', 'redaktionsplan']" :key="category" :value="category">
          <!-- Search Bar -->
          <v-row class="mb-4" v-if="shouldShowCategory(category)">
            <v-col cols="12" md="4" class="ml-auto">
              <v-text-field
                v-model="searchQueries[category]"
                dense
                outlined
                rounded
                dark
                hide-details
                placeholder="Suchen..."
                prepend-inner-icon="mdi-magnify"
                clearable></v-text-field>
            </v-col>
          </v-row>

          <!-- Studio Hinweis-Banner -->
          <v-alert
            v-if="shouldShowCategory(category) && !showAllStudios && otherStudioTodoCount > 0"
            type="warning"
            text
            dense
            dark
            class="mb-3 rounded-lg">
            <div class="d-flex flex-column flex-sm-row align-sm-center" style="gap: 8px">
              <div class="flex-grow-1">
                Es gibt <strong>{{ otherStudioTodoCount }}</strong> weitere ToDos in anderen Studios.
              </div>
              <v-btn
                small
                text
                color="warning"
                class="align-self-start align-self-sm-center"
                @click="
                  showAllStudios = true
                  reloadTodos()
                ">
                Alle anzeigen
              </v-btn>
            </div>
          </v-alert>

          <!-- Meine ToDos Abschnitt -->
          <v-card
            v-if="shouldShowCategory(category) && getMyTodos(category).length > 0 && !onlyUserTodos"
            class="mb-4 rounded-lg hover-bg"
            color="#1E1E1E"
            dark
            outlined
            style="border-left: 3px solid #4caf50; cursor: pointer; transition: background-color 0.2s"
            @click="toggleOnlyUserTodos">
            <v-card-text class="d-flex align-center py-3">
              <v-icon color="green" class="mr-3">mdi-account-check</v-icon>
              <div class="text-subtitle-2 white--text">
                Dir sind hier <strong>{{ getMyTodos(category).length }} ToDo(s)</strong> zugewiesen.
              </div>
              <v-spacer></v-spacer>
              <v-btn small color="green" outlined>
                <v-icon left small>mdi-filter</v-icon>
                ansehen
              </v-btn>
            </v-card-text>
          </v-card>

          <v-alert v-if="shouldShowCategory(category) && onlyUserTodos" color="green" outlined dense dark class="mb-4 rounded-lg">
            <v-row align="center" no-gutters>
              <v-col class="grow text-subtitle-2">
                <v-icon color="green" left small>mdi-filter-check</v-icon>
                Du siehst aktuell nur deine eigenen ToDos.
              </v-col>
              <v-col class="shrink">
                <v-btn small text color="green" @click="toggleOnlyUserTodos">
                  <v-icon left small>mdi-close</v-icon>
                  Filter aufheben
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>

          <!-- Board View -->
          <div v-if="shouldShowCategory(category) && viewMode === 'board'" class="d-flex overflow-x-auto fill-height justify-center">
            <!-- Backlog Column -->
            <div
              class="board-column mr-4 px-2"
              style="min-width: 300px; background: #2c2c2c; border-radius: 8px"
              @dragover.prevent
              @drop="onDrop($event, 'backlog')">
              <h3 class="white--text pa-2 text-center">Backlog</h3>
              <v-card
                v-for="item in getBoardItems(category, 'backlog')"
                :key="item._id"
                class="mb-2"
                dark
                color="#1E1E1E"
                draggable="true"
                @dragstart="onDragStart($event, item)"
                @click="openDetailDialog(item)"
                style="cursor: move">
                <v-card-title class="subtitle-2">{{ item.title }}</v-card-title>
                <v-card-subtitle class="caption d-flex justify-space-between align-center">
                  <span>{{ formatDate(item.createdAt) }}</span>
                  <div class="d-flex align-center">
                    <v-chip v-if="item.subtaskCount > 0" x-small outlined color="indigo lighten-2" class="mr-1">
                      <v-icon left x-small>mdi-format-list-bulleted</v-icon> {{ item.subtaskCount }}
                    </v-chip>
                    <v-chip x-small :color="getPriorityColor(item.priority)">{{ mapPriorityName(item.priority) }}</v-chip>
                  </div>
                  <div class="d-flex align-center mt-1">
                    <template v-if="item.assignedUsers && item.assignedUsers.length > 0">
                      <v-tooltip bottom v-for="(u, i) in item.assignedUsers" :key="i">
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar size="24" color="grey darken-3" class="white--text mr-1" v-bind="attrs" v-on="on" style="border: 1px solid #555">
                            <span style="font-size: 10px">{{ u.user.vorname[0] }}{{ u.user.nachname[0] }}</span>
                          </v-avatar>
                        </template>
                        <span>{{ u.user.vorname }} {{ u.user.nachname }}</span>
                      </v-tooltip>
                    </template>
                  </div>
                </v-card-subtitle>
              </v-card>
            </div>
            <!-- In Progress Column -->
            <div
              class="board-column mr-4 px-2"
              style="min-width: 300px; background: #2c2c2c; border-radius: 8px"
              @dragover.prevent
              @drop="onDrop($event, 'in_progress')">
              <h3 class="white--text pa-2 text-center">In Bearbeitung</h3>
              <v-card
                v-for="item in getBoardItems(category, 'in_progress')"
                :key="item._id"
                class="mb-2"
                dark
                color="#1E1E1E"
                draggable="true"
                @dragstart="onDragStart($event, item)"
                @click="openDetailDialog(item)"
                style="cursor: move">
                <v-card-title class="subtitle-2">{{ item.title }}</v-card-title>
                <v-card-subtitle class="caption d-flex justify-space-between align-center">
                  <span>{{ formatDate(item.createdAt) }}</span>
                  <div class="d-flex align-center">
                    <v-chip v-if="item.subtaskCount > 0" x-small outlined color="indigo lighten-2" class="mr-1">
                      <v-icon left x-small>mdi-format-list-bulleted</v-icon> {{ item.subtaskCount }}
                    </v-chip>
                    <v-chip x-small :color="getPriorityColor(item.priority)">{{ mapPriorityName(item.priority) }}</v-chip>
                  </div>
                  <div class="d-flex align-center mt-1">
                    <template v-if="item.assignedUsers && item.assignedUsers.length > 0">
                      <v-tooltip bottom v-for="(u, i) in item.assignedUsers" :key="i">
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar size="24" color="grey darken-3" class="white--text mr-1" v-bind="attrs" v-on="on" style="border: 1px solid #555">
                            <span style="font-size: 10px">{{ u.user.vorname[0] }}{{ u.user.nachname[0] }}</span>
                          </v-avatar>
                        </template>
                        <span>{{ u.user.vorname }} {{ u.user.nachname }}</span>
                      </v-tooltip>
                    </template>
                  </div>
                </v-card-subtitle>
              </v-card>
            </div>
            <!-- Done Column -->
            <div
              class="board-column px-2"
              style="min-width: 300px; background: #2c2c2c; border-radius: 8px"
              @dragover.prevent
              @drop="onDrop($event, 'done')">
              <h3 class="white--text pa-2 text-center">Erledigt</h3>
              <v-card
                v-for="item in getBoardItems(category, 'done')"
                :key="item._id"
                class="mb-2"
                dark
                color="#1E1E1E"
                draggable="true"
                @dragstart="onDragStart($event, item)"
                @click="openDetailDialog(item)"
                style="cursor: move">
                <v-card-title class="subtitle-2">{{ item.title }}</v-card-title>
                <v-card-subtitle class="caption d-flex justify-space-between align-center">
                  <span>{{ formatDate(item.resolvedAt || item.createdAt) }}</span>
                  <div class="d-flex align-center">
                    <v-chip v-if="item.subtaskCount > 0" x-small outlined color="indigo lighten-2" class="mr-1">
                      <v-icon left x-small>mdi-format-list-bulleted</v-icon> {{ item.subtaskCount }}
                    </v-chip>
                    <v-icon small color="green">mdi-check</v-icon>
                  </div>
                  <div class="d-flex align-center mt-1">
                    <template v-if="item.assignedUsers && item.assignedUsers.length > 0">
                      <v-tooltip bottom v-for="(u, i) in item.assignedUsers" :key="i">
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar size="24" color="grey darken-3" class="white--text mr-1" v-bind="attrs" v-on="on" style="border: 1px solid #555">
                            <span style="font-size: 10px">{{ u.user.vorname[0] }}{{ u.user.nachname[0] }}</span>
                          </v-avatar>
                        </template>
                        <span>{{ u.user.vorname }} {{ u.user.nachname }}</span>
                      </v-tooltip>
                    </template>
                  </div>
                </v-card-subtitle>
              </v-card>
            </div>
          </div>

          <!-- Timeline View -->
          <div v-if="shouldShowCategory(category) && viewMode === 'timeline'" class="fill-height dark">
            <!-- Timeline Controls -->
            <div class="d-flex align-center mb-2 flex-wrap" style="gap: 8px">
              <v-menu v-model="timelineStartDateMenu[category]" :close-on-content-click="false" offset-y min-width="auto" dark>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined dark v-bind="attrs" v-on="on">
                    <v-icon left small>mdi-calendar-start</v-icon>
                    {{ timelineStartDate ? $moment(timelineStartDate).format("DD.MM.YYYY") : "Heute" }}
                  </v-btn>
                </template>
                <v-date-picker v-model="timelineStartDate" @input="timelineStartDateMenu[category] = false" dark> </v-date-picker>
              </v-menu>
              <v-btn v-if="timelineStartDate" x-small icon dark @click="timelineStartDate = null">
                <v-icon small>mdi-close</v-icon>
              </v-btn>

              <v-btn-toggle v-model="timelineScale" mandatory dense dark class="ml-2">
                <v-btn small value="day" outlined>Tag</v-btn>
                <v-btn small value="week" outlined>Woche</v-btn>
                <v-btn small value="month" outlined>Monat</v-btn>
              </v-btn-toggle>
            </div>

            <div class="timeline-scrollable overflow-auto" style="background: #2c2c2c; border-radius: 8px; position: relative">
              <div style="min-width: 100%; width: max-content">
                <!-- Sticky Header: Monate + Tage -->
                <div style="position: sticky; top: 0; z-index: 2; background: #2c2c2c">
                  <!-- Monatsleiste -->
                  <div v-if="timelineMonths.length > 0" class="d-flex" style="padding-left: 200px; border-bottom: 1px solid #555">
                    <div
                      v-for="month in timelineMonths"
                      :key="month.key"
                      :style="{ minWidth: month.width + 'px', width: month.width + 'px' }"
                      class="text-center caption white--text py-1"
                      style="border-right: 1px solid #555; font-weight: bold; background: #333">
                      {{ month.label }}
                    </div>
                  </div>
                  <!-- Tagesleiste -->
                  <div class="d-flex" style="padding-left: 200px; border-bottom: 1px solid #424242">
                    <div
                      v-for="day in timelineDays"
                      :key="day.toISOString()"
                      :style="{ minWidth: timelineColumnWidth + 'px', width: timelineColumnWidth + 'px' }"
                      style="text-align: center; border-right: 1px solid #424242; font-size: 10px; display: flex; flex-direction: column"
                      class="grey--text py-1"
                      :class="{ 'blue-grey darken-3': day.isSame($moment(), 'day') }">
                      <div class="flex-grow-1">
                        <template v-if="timelineScale === 'day'">{{ day.format("DD") }}<br />{{ day.format("dd") }}</template>
                        <template v-else-if="timelineScale === 'week'">KW {{ day.isoWeek() }}</template>
                        <template v-else>{{ day.format("MMM YY") }}</template>
                      </div>

                      <div v-if="activeTab === 'redaktionsplan'" class="px-1 mt-1">
                        <v-tooltip bottom v-for="event in getEventsForDay(day)" :key="event._id" open-on-click>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="rounded hover-bg-light"
                              style="
                                background-color: #e91e63;
                                color: white;
                                font-size: 8px;
                                padding: 2px;
                                margin-bottom: 2px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                cursor: pointer;
                              ">
                              {{ timelineColumnWidth < 50 ? "★" : event.name }}
                            </div>
                          </template>
                          <span>
                            <strong>{{ event.name }}</strong
                            ><br />
                            {{ $moment(event.startDate).format("DD.MM.YYYY") }}
                            <template v-if="event.endDate && event.startDate !== event.endDate">
                              - {{ $moment(event.endDate).format("DD.MM.YYYY") }}</template
                            >
                          </span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="py-2">
                  <div
                    v-for="item in getTimelineItems(category)"
                    :key="item._id"
                    class="d-flex align-center border-bottom mb-1 hover-bg"
                    style="height: 40px; position: relative"
                    @click="openDetailDialog(item)">
                    <div
                      style="width: 200px; left: 0; background: #2c2c2c; border-right: 1px solid #424242"
                      class="d-flex align-center fill-height pr-2"
                      :style="{ paddingLeft: item.level * 16 + 8 + 'px' }"
                      :title="item.title">
                      <div
                        v-if="item.level > 0"
                        style="
                          border-left: 1px solid #555;
                          border-bottom: 1px solid #555;
                          width: 8px;
                          height: 12px;
                          margin-right: 4px;
                          margin-bottom: 2px;
                        "></div>

                      <v-btn
                        v-if="item.hasChildren"
                        icon
                        x-small
                        width="20"
                        height="20"
                        class="mr-1 flex-shrink-0"
                        @click.stop="toggleExpand(item._id)">
                        <v-icon x-small>{{ expandedParents[item._id] ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                      </v-btn>

                      <div v-else-if="!item.hasChildren && item.level === 0" style="width: 24px" class="flex-shrink-0"></div>

                      <v-icon x-small :color="getPriorityColor(item.priority)" class="mr-1 flex-shrink-0">mdi-circle-small</v-icon>

                      <span class="text-truncate caption" :class="{ 'grey--text': item.resolved }">
                        {{ item.title }}
                      </span>
                    </div>

                    <div class="flex-grow-1" style="position: relative; height: 100%">
                      <div
                        :style="getTimelineBarStyle(item)"
                        class="rounded white--text pl-1 d-flex align-center caption"
                        :class="getTimelineBarColor(item)"
                        style="overflow: hidden; white-space: nowrap; cursor: pointer">
                        <v-icon v-if="item.subtaskCount > 0" x-small left color="white">mdi-format-list-bulleted</v-icon>
                        {{ item.title }} <span v-if="item.subtaskCount > 0" class="ml-1">({{ item.subtaskCount }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- List View -->
          <v-data-table
            v-if="shouldShowCategory(category) && viewMode === 'list'"
            :headers="headers"
            :items="getSortedTodos(category)"
            :items-per-page="-1"
            dark
            class="elevation-1 rounded-lg"
            @click:row="openDetailDialog"
            style="cursor: pointer; background-color: #1e1e1e">
            <template v-slot:item.priority="{ item }">
              <v-chip small :color="getPriorityColor(item.priority)" dark>{{ mapPriorityName(item.priority) }}</v-chip>
            </template>

            <template v-slot:item.createdAt="{ item }">
              {{ $moment(item.createdAt).format("DD.MM.YY HH:mm") }}
            </template>

            <template v-slot:item.title="{ item }">
              <div class="d-flex align-center" style="height: 100%">
                <v-btn v-if="item.hasChildren" icon x-small @click.stop="toggleExpand(item._id)" class="mr-1 flex-shrink-0">
                  <v-icon>{{ expandedParents[item._id] ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>

                <div v-else-if="!item.hasChildren" style="width: 28px" class="d-inline-block flex-shrink-0"></div>

                <div class="d-flex align-center text-truncate">
                  <v-icon v-if="item.level > 0" x-small class="mr-2" color="grey darken-1">mdi-subdirectory-arrow-right</v-icon>

                  <span
                    :class="{
                      'font-weight-bold text-subtitle-1': item.level === 0,
                      'text-body-2 grey--text text--lighten-2': item.level > 0,
                      'text-decoration-line-through grey--text': item.resolved,
                    }"
                    class="todo-title-truncate">
                    {{ item.title }}
                  </span>

                  <v-chip x-small outlined class="ml-2" v-if="item.hasChildren" color="grey darken-1">
                    {{ item.children.length }}
                  </v-chip>
                </div>
              </div>
            </template>

            <template v-slot:item.createdBy="{ item }"> {{ item.createdBy.vorname }} {{ item.createdBy.nachname }} </template>
            <template v-slot:item.assignedUsers="{ item }">
              <span v-if="item.assignedUsers.length">{{ item.assignedUsers.length }} User</span>
              <span v-else>-</span>
            </template>
          </v-data-table>

          <v-alert v-if="shouldShowCategory(category) && getSortedTodos(category).length === 0" type="info" text dark class="mt-4 rounded-lg">
            Keine ToDos in dieser Kategorie gefunden.
          </v-alert>
        </v-tab-item>

        <!-- Resolved Tab -->
        <v-tab-item value="resolved">
          <v-row class="mb-4">
            <v-col cols="12" md="4" class="ml-auto">
              <v-text-field
                v-model="searchQueries['resolved']"
                dense
                outlined
                rounded
                dark
                hide-details
                placeholder="Suche in erledigten..."
                prepend-inner-icon="mdi-magnify"
                clearable></v-text-field>
            </v-col>
          </v-row>

          <div v-if="groupedResolvedTodosFiltered.length === 0" class="d-flex justify-center mt-10">
            <v-alert type="info" text dark>Keine erledigten ToDo's gefunden</v-alert>
          </div>

          <v-timeline dense align-top v-else dark>
            <div v-for="yearGroup in groupedResolvedTodosFiltered" :key="yearGroup.year">
              <v-timeline-item hide-dot class="pb-0" dark>
                <span class="text-h6 font-weight-bold grey--text">{{ yearGroup.year }}</span>
              </v-timeline-item>

              <div v-for="monthGroup in yearGroup.months" :key="monthGroup.monthName">
                <v-timeline-item small color="grey lighten-1" dark>
                  <template v-slot:opposite>
                    <span class="font-weight-bold">{{ monthGroup.monthName }}</span>
                  </template>
                  <v-card class="elevation-1 rounded-lg mb-4" color="#1E1E1E" dark>
                    <v-card-title class="subtitle-2 grey darken-3 py-2"> {{ monthGroup.monthName }} ({{ monthGroup.totalCount }}) </v-card-title>
                    <v-card-text class="pa-0">
                      <v-expansion-panels accordion flat dark>
                        <v-expansion-panel v-if="monthGroup.techniker.length > 0" class="grey darken-4">
                          <v-expansion-panel-header class="caption font-weight-bold grey--text"
                            >Techniker ({{ monthGroup.techniker.length }})</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-list dense dark color="#1E1E1E">
                              <v-list-item
                                v-for="todo in monthGroup.techniker"
                                :key="todo._id"
                                @click="openDetailDialog(todo)"
                                class="rounded-lg mb-1 hover-bg">
                                <v-list-item-content>
                                  <v-list-item-title class="font-weight-medium">{{ todo.title }}</v-list-item-title>
                                  <v-list-item-subtitle class="grey--text">{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- Repeat for other categories in resolved view -->
                        <v-expansion-panel v-if="monthGroup.marketing.length > 0" class="grey darken-4">
                          <v-expansion-panel-header class="caption font-weight-bold grey--text"
                            >Marketing ({{ monthGroup.marketing.length }})</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-list dense dark color="#1E1E1E">
                              <v-list-item
                                v-for="todo in monthGroup.marketing"
                                :key="todo._id"
                                @click="openDetailDialog(todo)"
                                class="rounded-lg mb-1 hover-bg">
                                <v-list-item-content>
                                  <v-list-item-title class="font-weight-medium">{{ todo.title }}</v-list-item-title>
                                  <v-list-item-subtitle class="grey--text">{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="monthGroup.coo.length > 0 && userService.hasRight('coo_toDoListItems')" class="grey darken-4">
                          <v-expansion-panel-header class="caption font-weight-bold grey--text"
                            >COO ({{ monthGroup.coo.length }})</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-list dense dark color="#1E1E1E">
                              <v-list-item
                                v-for="todo in monthGroup.coo"
                                :key="todo._id"
                                @click="openDetailDialog(todo)"
                                class="rounded-lg mb-1 hover-bg">
                                <v-list-item-content>
                                  <v-list-item-title class="font-weight-medium">{{ todo.title }}</v-list-item-title>
                                  <v-list-item-subtitle class="grey--text">{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="monthGroup.cl.length > 0 && userService.hasRight('cl_toDoListItems')" class="grey darken-4">
                          <v-expansion-panel-header class="caption font-weight-bold grey--text"
                            >CL ({{ monthGroup.cl.length }})</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-list dense dark color="#1E1E1E">
                              <v-list-item
                                v-for="todo in monthGroup.cl"
                                :key="todo._id"
                                @click="openDetailDialog(todo)"
                                class="rounded-lg mb-1 hover-bg">
                                <v-list-item-content>
                                  <v-list-item-title class="font-weight-medium">{{ todo.title }}</v-list-item-title>
                                  <v-list-item-subtitle class="grey--text">{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="monthGroup.it.length > 0 && userService.hasRight('it_toDoListItems')" class="grey darken-4">
                          <v-expansion-panel-header class="caption font-weight-bold grey--text"
                            >IT ({{ monthGroup.it.length }})</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-list dense dark color="#1E1E1E">
                              <v-list-item
                                v-for="todo in monthGroup.it"
                                :key="todo._id"
                                @click="openDetailDialog(todo)"
                                class="rounded-lg mb-1 hover-bg">
                                <v-list-item-content>
                                  <v-list-item-title class="font-weight-medium">{{ todo.title }}</v-list-item-title>
                                  <v-list-item-subtitle class="grey--text">{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </div>
            </div>
          </v-timeline>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- Create / Edit Dialog -->
    <v-dialog v-model="todoDialog" max-width="700px" persistent transition="dialog-bottom-transition" dark :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card class="rounded-xl" dark color="#1E1E1E">
        <v-toolbar color="#2C2C2C" dark flat>
          <v-toolbar-title>
            <span class="text-h6 font-weight-bold white--text">{{ todoDialogTitle }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeTodoDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-form ref="todoForm" v-model="formValid">
            <v-row>
              <v-col cols="12">
                <user-search
                  :value="createdByUser"
                  :key="assignedUserKey"
                  ignoreRights
                  instructor
                  label="Erstellt von"
                  @update="updateCreatedByUser"
                  outlined
                  dense
                  dark></user-search>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="editedTodo.category"
                  :items="availableCategories"
                  label="Kategorie"
                  outlined
                  dense
                  dark
                  :disabled="isCategoryDisabled(editedTodo.category)"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-if="editedTodo.category === 'marketing' || editedTodo.category === 'redaktionsplan'"
                  v-model="editedTodo.subcategory"
                  :items="['Umbau', 'Events', 'News', 'Feiertag', 'Specialdays', 'Sonstiges']"
                  label="Tag"
                  outlined
                  dense
                  dark></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'coo' && userService.hasRight('coo_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedCooSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'cl' && userService.hasRight('cl_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedClSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'it' && userService.hasRight('it_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedITSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- Parent Selection -->
                <!-- Parent Selection (Tree View Trigger) -->
                <v-text-field
                  :value="editedTodoParentTitle"
                  label="Überkategorie (Optional)"
                  outlined
                  dense
                  dark
                  readonly
                  @click="openParentSelectionDialog"
                  clearable
                  @click:clear="editedTodo.parent = null"
                  :disabled="!editedTodo.category"
                  prepend-inner-icon="mdi-file-tree"
                  hint="Klicken zum Auswählen"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedTodo.title" label="Titel" :rules="[(v) => !!v || 'Pflichtfeld']" outlined dense dark></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="editedTodo.startDate" label="Startdatum" type="date" outlined dense dark></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="editedTodo.dueDate" label="Fälligkeitsdatum" type="date" outlined dense dark></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="editedTodo.duration" label="Dauer (Std)" type="number" outlined dense dark></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedTodo.description" label="Beschreibung" outlined rows="4" dark></v-textarea>
              </v-col>
              <v-col cols="12" v-if="editedTodo.category === 'marketing'">
                <div class="pa-4 mb-4 rounded-lg grey darken-4" style="width: 100%">
                  <div class="text-subtitle-1 font-weight-bold white--text mb-4">
                    <v-icon left color="pink">mdi-bullhorn</v-icon> Marketing Checkliste
                  </div>

                  <v-text-field
                    v-model="editedTodo.marketingDetails.contactInfo"
                    label="Auftraggeber / Center / Name / E-Mail / Telefon"
                    outlined
                    dense
                    dark></v-text-field>

                  <v-select
                    v-model="editedTodo.marketingDetails.targetAudience"
                    :items="targetAudienceOptions"
                    label="Zielgruppe"
                    multiple
                    chips
                    outlined
                    dense
                    dark></v-select>

                  <div class="mb-4 pa-3 rounded" style="border: 1px solid #555">
                    <div class="caption grey--text mb-2">Projektart (Mehrfachauswahl möglich)</div>
                    <div v-for="type in projectTypeOptions" :key="type.main">
                      <v-checkbox
                        v-model="marketingSelectedMainTypes"
                        :label="type.main"
                        :value="type.main"
                        hide-details
                        dense
                        dark
                        class="mt-0"></v-checkbox>

                      <v-select
                        v-if="marketingSelectedMainTypes.includes(type.main) && type.subs.length > 0"
                        v-model="marketingSelectedSubTypes[type.main]"
                        :items="type.subs"
                        multiple
                        chips
                        dense
                        outlined
                        dark
                        class="ml-8 mt-2"
                        label="Details auswählen (Print, Digital, etc.)"></v-select>
                    </div>
                  </div>

                  <v-text-field
                    v-if="marketingSelectedMainTypes.includes('Print')"
                    v-model="editedTodo.marketingDetails.printRun"
                    label="Druckauflage"
                    outlined
                    dense
                    dark></v-text-field>

                  <v-row dense class="mb-2">
                    <v-col cols="6"
                      ><v-checkbox v-model="editedTodo.marketingDetails.hasText" label="Text vorhanden?" dense dark hide-details></v-checkbox
                    ></v-col>
                    <v-col cols="6"
                      ><v-checkbox v-model="editedTodo.marketingDetails.hasImages" label="Bilder vorhanden?" dense dark hide-details></v-checkbox
                    ></v-col>
                  </v-row>

                  <v-textarea v-model="editedTodo.marketingDetails.contentNotes" label="Notizen zum Inhalt" outlined rows="2" dense dark></v-textarea>
                  <v-textarea
                    v-model="editedTodo.marketingDetails.formatNotes"
                    label="Format & Anforderungen"
                    outlined
                    rows="2"
                    dense
                    dark></v-textarea>
                </div>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-if="canEditPriority()"
                  v-model="editedTodo.priority"
                  :items="priorityItems"
                  label="Priorität"
                  outlined
                  dense
                  dark
                  :rules="[(v) => !!v || 'Pflichtfeld']">
                  <template v-slot:selection="{ item }">
                    <v-chip small :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-chip small :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  @change="changeStudioSelectToDo"
                  v-if="
                    userService.hasRight('todo_fetchAllMarketing') ||
                    userService.hasRight('todo_fetchAlltoDoListItemsTechniker') ||
                    userService.hasRight('coo_fetchAlltoDoListItems') ||
                    userService.hasRight('cl_fetchAlltoDoListItems') ||
                    userService.hasRight('it_fetchAlltoDoListItems')
                  "
                  :items="studios"
                  label="Studio"
                  v-model="editedTodo.studio"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  dark></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click="closeTodoDialog" :disabled="isSaving">Abbrechen</v-btn>

          <v-btn color="primary" elevation="0" @click="saveTodo" :loading="isSaving" :disabled="!formValid || isSaving"> Speichern </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detail Dialog -->
    <v-dialog v-model="detailDialog" fullscreen hide-overlay transition="dialog-bottom-transition" dark>
      <v-card dark>
        <v-toolbar dark color="#2C2C2C">
          <v-btn icon dark @click="closeDetailDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>ToDo Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleEditMode">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            dark
            class="mr-2"
            v-if="currentTodo?.category !== 'coo' && currentTodo?.category !== 'cl' && currentTodo?.category !== 'it'"
            @click="deleteCurrentTodo">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-toolbar>

        <div fluid class="pa-0 ma-0 fill-height d-flex align-start">
          <v-row class="fill-height ma-0">
            <!-- Left Column: Details -->
            <v-col cols="12" md="5" lg="4" class="fill-height overflow-y-auto pa-6 border-right" style="background-color: #1e1e1e">
              <!-- Edit Mode Form -->
              <div v-if="editMode">
                <h3 class="text-h6 mb-4 white--text">Bearbeiten</h3>
                <v-text-field v-model="editedTodo.title" label="Titel" outlined dense dark></v-text-field>
                <v-textarea v-model="editedTodo.description" label="Beschreibung" outlined rows="5" dark></v-textarea>
                <v-expand-transition>
                  <div v-if="editedTodo.category === 'marketing'" class="pa-4 mb-4 rounded-lg grey darken-4 border-marketing">
                    <div class="text-subtitle-1 font-weight-bold white--text mb-4">
                      <v-icon left color="pink">mdi-bullhorn</v-icon> Marketing Checkliste bearbeiten
                    </div>

                    <v-text-field v-model="editedTodo.marketingDetails.contactInfo" label="Auftraggeber / Info" outlined dense dark></v-text-field>

                    <v-select
                      v-model="editedTodo.marketingDetails.targetAudience"
                      :items="targetAudienceOptions"
                      label="Zielgruppe"
                      multiple
                      chips
                      outlined
                      dense
                      dark></v-select>

                    <div class="mb-4 pa-3 rounded" style="border: 1px solid #555">
                      <div class="caption grey--text mb-2">Projektart</div>
                      <div v-for="type in projectTypeOptions" :key="type.main">
                        <v-checkbox
                          v-model="marketingSelectedMainTypes"
                          :label="type.main"
                          :value="type.main"
                          hide-details
                          dense
                          dark
                          class="mt-0"></v-checkbox>

                        <v-select
                          v-if="marketingSelectedMainTypes.includes(type.main) && type.subs.length > 0"
                          v-model="marketingSelectedSubTypes[type.main]"
                          :items="type.subs"
                          multiple
                          chips
                          dense
                          outlined
                          dark
                          class="ml-8 mt-2"
                          label="Details"></v-select>
                      </div>
                    </div>

                    <v-text-field
                      v-if="marketingSelectedMainTypes.includes('Print')"
                      v-model="editedTodo.marketingDetails.printRun"
                      label="Druckauflage"
                      outlined
                      dense
                      dark></v-text-field>

                    <v-row dense>
                      <v-col cols="6"><v-checkbox v-model="editedTodo.marketingDetails.hasText" label="Text da?" dense dark></v-checkbox></v-col>
                      <v-col cols="6"><v-checkbox v-model="editedTodo.marketingDetails.hasImages" label="Bilder da?" dense dark></v-checkbox></v-col>
                    </v-row>

                    <v-textarea v-model="editedTodo.marketingDetails.contentNotes" label="Inhalt Notizen" outlined rows="2" dense dark></v-textarea>
                    <v-textarea v-model="editedTodo.marketingDetails.formatNotes" label="Format Notizen" outlined rows="2" dense dark></v-textarea>
                  </div>
                </v-expand-transition>
                <v-select label="Kategorie" v-model="editedTodo.category" :items="availableCategories" outlined dense disabled dark></v-select>

                <!-- Tag/Subcategory Editing -->
                <v-select
                  v-if="editedTodo.category === 'marketing' || editedTodo.category === 'redaktionsplan'"
                  v-model="editedTodo.subcategory"
                  :items="['Umbau', 'Events', 'News', 'Feiertag', 'Specialdays', 'Sonstiges']"
                  label="Tag"
                  outlined
                  dense
                  dark
                  clearable></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'coo' && userService.hasRight('coo_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedCooSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark
                  clearable></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'cl' && userService.hasRight('cl_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedClSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark
                  clearable></v-select>
                <v-select
                  v-else-if="editedTodo.category === 'it' && userService.hasRight('it_toDoListItems')"
                  v-model="editedTodo.subcategory"
                  :items="sortedITSubcategories"
                  label="Tag"
                  outlined
                  dense
                  dark
                  clearable></v-select>

                <v-autocomplete
                  v-model="editedTodo.parent"
                  :items="potentialParents"
                  item-text="title"
                  item-value="_id"
                  label="Überkategorie (gleiches Studio)"
                  outlined
                  dense
                  dark
                  clearable
                  :disabled="!editedTodo.category">
                  <template v-slot:item="{ item }">
                    <v-list-item-content :class="{ 'grey--text': item.disabled }">
                      <v-list-item-title>
                        {{ item.title }}
                        <span v-if="item.disabled" class="caption font-italic ml-2"> 🚫 {{ item.disabledText }} </span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption grey--text text-truncate">
                        {{ item.description }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>

                <v-row dense>
                  <v-col cols="6">
                    <v-text-field v-model="editedTodo.startDate" label="Start" type="date" outlined dense dark></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="editedTodo.dueDate" label="Fällig" type="date" outlined dense dark></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="editedTodo.duration" label="Dauer (h)" type="number" outlined dense dark></v-text-field>
                  </v-col>
                </v-row>

                <v-select label="Priorität" v-model="editedTodo.priority" :items="priorityItems" outlined dense dark>
                  <template v-slot:selection="{ item }">
                    <v-chip small :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
                  </template>
                </v-select>
                <v-select
                  v-if="
                    userService.hasRight('todo_fetchAllMarketing') ||
                    userService.hasRight('todo_fetchAlltoDoListItemsTechniker') ||
                    userService.hasRight('coo_fetchAlltoDoListItems') ||
                    userService.hasRight('cl_fetchAlltoDoListItems') ||
                    userService.hasRight('it_fetchAlltoDoListItems')
                  "
                  @change="changeStudioSelectToDo"
                  :items="studios"
                  label="Studio"
                  v-model="editedTodo.studio"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  dark></v-select>

                <div class="d-flex justify-end mt-4">
                  <v-btn text color="grey" class="mr-2" @click="toggleEditMode" :disabled="isSaving">Abbrechen</v-btn>
                  <v-btn color="primary" @click="saveEdit" :loading="isSaving" :disabled="isSaving"> Speichern </v-btn>
                </div>
              </div>

              <!-- View Mode -->
              <div v-else>
                <div class="d-flex align-center mb-2">
                  <v-chip small :color="currentTodo?.resolved ? 'green' : 'orange'" dark class="mr-2">
                    {{ currentTodo?.resolved ? "Erledigt" : "Offen" }}
                  </v-chip>
                  <v-chip small outlined dark color="grey lighten-1" class="mr-2">{{ formatDate(currentTodo?.createdAt) }}</v-chip>
                  <v-chip small :color="getPriorityColor(currentTodo?.priority)" dark>{{ mapPriorityName(currentTodo?.priority) }}</v-chip>
                </div>

                <div class="d-flex flex-wrap align-center mb-4">
                  <v-chip v-if="currentTodo?.startDate" small label outlined color="blue grey lighten-2" dark class="mr-2 my-1">
                    Start: {{ $moment(currentTodo.startDate).format("DD.MM.YY") }}
                  </v-chip>
                  <v-chip v-if="currentTodo?.dueDate" small label outlined color="red lighten-2" dark class="mr-2 my-1">
                    Fällig: {{ $moment(currentTodo.dueDate).format("DD.MM.YY") }}
                  </v-chip>
                  <v-chip v-if="currentTodo?.duration" small label outlined color="teal lighten-2" dark class="mr-2 my-1">
                    {{ currentTodo.duration }} h
                  </v-chip>
                  <!-- Parent Display -->
                  <v-chip
                    class="my-1"
                    v-if="currentTodo?.parent"
                    small
                    label
                    outlined
                    color="orange lighten-2"
                    dark
                    @click.stop="openDetailDialogById(currentTodo.parent._id || currentTodo.parent)"
                    style="cursor: pointer">
                    <v-icon left x-small>mdi-arrow-up</v-icon>
                    {{ currentTodoParentTitle }}
                  </v-chip>
                </div>

                <h2 class="text-h5 font-weight-bold mb-4 white--text">
                  {{ currentTodo?.title }}
                  <v-btn icon small dark @click="translateTitle" color="blue lighten-2"><v-icon small>mdi-translate</v-icon></v-btn>
                </h2>

                <!-- Subtasks (Planner Style) with Indentation Visuals -->
                <div v-if="currentTodoSubtasks.length > 0" class="mb-4 pa-3" style="background: #2c2c2c; border-radius: 8px">
                  <div class="subtitle-2 grey--text mb-2 ml-1">Unteraufgaben</div>
                  <div
                    v-for="sub in currentTodoSubtasks"
                    :key="sub._id"
                    class="d-flex align-center py-2 px-2 hover-bg-light rounded mb-1"
                    style="cursor: pointer; border-left: 3px solid #666"
                    @click="openDetailDialog(sub)">
                    <v-icon small :color="sub.resolved ? 'green' : 'grey'" class="mr-3">
                      {{ sub.resolved ? "mdi-checkbox-marked-circle" : "mdi-checkbox-blank-circle-outline" }}
                    </v-icon>
                    <span :class="{ 'text-decoration-line-through grey--text': sub.resolved, 'white--text': !sub.resolved }">{{ sub.title }}</span>
                    <v-spacer></v-spacer>
                    <v-chip x-small class="ml-2" v-if="sub.assignedUsers.length">{{ sub.assignedUsers.length }} Users</v-chip>
                  </div>
                </div>

                <v-card outlined class="mb-4 pa-4 rounded-lg" style="background-color: #2c2c2c; border-color: #424242" dark>
                  <div class="text-body-1 white--text" style="white-space: pre-wrap">{{ currentTodo?.description }}</div>
                  <div class="d-flex justify-end mt-2">
                    <v-btn icon small dark @click="copyTextToClipboard(currentTodo?.description)"><v-icon small>mdi-content-copy</v-icon></v-btn>
                    <v-btn icon small dark @click="translateText" color="blue lighten-2"><v-icon small>mdi-translate</v-icon></v-btn>
                  </div>
                  <v-card
                    v-if="currentTodo?.category === 'marketing' && currentTodo?.marketingDetails"
                    outlined
                    class="mb-4 pa-4 rounded-lg"
                    style="background-color: #2c2c2c; border-color: #424242"
                    dark>
                    <div class="text-subtitle-2 grey--text mb-3">Marketing Details</div>

                    <div v-if="currentTodo.marketingDetails.contactInfo" class="mb-2">
                      <span class="caption grey--text">Auftraggeber / Info:</span><br />
                      <span class="white--text">{{ currentTodo.marketingDetails.contactInfo }}</span>
                    </div>

                    <div v-if="currentTodo.marketingDetails.targetAudience?.length" class="mb-2">
                      <span class="caption grey--text">Zielgruppe:</span><br />
                      <v-chip v-for="aud in currentTodo.marketingDetails.targetAudience" :key="aud" x-small color="indigo" dark class="mr-1 mt-1">{{
                        aud
                      }}</v-chip>
                    </div>

                    <div v-if="currentTodo.marketingDetails.projectTypes?.length" class="mb-2">
                      <span class="caption grey--text">Projektart:</span><br />
                      <div v-for="pt in currentTodo.marketingDetails.projectTypes" :key="pt.mainType" class="mt-1">
                        <v-chip small color="pink darken-2" dark class="mr-1">{{ pt.mainType }}</v-chip>
                        <v-chip v-for="sub in pt.subTypes" :key="sub" x-small outlined color="pink lighten-3" class="mr-1">{{ sub }}</v-chip>
                      </div>
                    </div>

                    <div class="d-flex mb-2 mt-3">
                      <v-chip x-small :color="currentTodo.marketingDetails.hasText ? 'green' : 'grey darken-2'" dark class="mr-2">
                        <v-icon left x-small>{{ currentTodo.marketingDetails.hasText ? "mdi-check" : "mdi-close" }}</v-icon> Text
                      </v-chip>
                      <v-chip x-small :color="currentTodo.marketingDetails.hasImages ? 'green' : 'grey darken-2'" dark>
                        <v-icon left x-small>{{ currentTodo.marketingDetails.hasImages ? "mdi-check" : "mdi-close" }}</v-icon> Bilder
                      </v-chip>
                    </div>

                    <div v-if="currentTodo.marketingDetails.printRun" class="mb-2">
                      <span class="caption grey--text">Druckauflage:</span>
                      <span class="white--text">{{ currentTodo.marketingDetails.printRun }}</span>
                    </div>

                    <v-divider class="my-3 border-grey-darken-3"></v-divider>

                    <div v-if="currentTodo.marketingDetails.contentNotes" class="mb-2">
                      <span class="caption grey--text">Notizen (Inhalt):</span>
                      <div class="white--text text-body-2" style="white-space: pre-wrap">{{ currentTodo.marketingDetails.contentNotes }}</div>
                    </div>

                    <div v-if="currentTodo.marketingDetails.formatNotes">
                      <span class="caption grey--text">Notizen (Format):</span>
                      <div class="white--text text-body-2" style="white-space: pre-wrap">{{ currentTodo.marketingDetails.formatNotes }}</div>
                    </div>
                  </v-card>
                </v-card>

                <v-divider class="mb-4" dark></v-divider>

                <div class="mb-4">
                  <div class="text-subtitle-2 grey--text mb-1">Erstellt von</div>
                  <div class="d-flex align-center">
                    <v-avatar size="32" color="primary" class="mr-2 white--text">
                      {{ currentTodo?.createdBy?.vorname[0] }}{{ currentTodo?.createdBy?.nachname[0] }}
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium white--text">{{ currentTodo?.createdBy?.vorname }} {{ currentTodo?.createdBy?.nachname }}</div>
                      <div class="caption grey--text">{{ currentTodo?.studio?.name }}</div>
                    </div>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="d-flex justify-space-between align-center mb-1">
                    <div class="text-subtitle-2 grey--text">Zugewiesen an</div>
                    <v-btn icon small color="primary" @click="toggleAssignment" v-if="userService.hasRight('todo_manageUsers')"
                      ><v-icon>mdi-account-plus</v-icon></v-btn
                    >
                  </div>

                  <v-expand-transition>
                    <div v-show="showAssignment" class="mb-3 pa-3 grey darken-3 rounded-lg">
                      <user-search
                        :value="newAssignedUser"
                        :key="assignedUserKey"
                        ignoreRights
                        instructor
                        label="Benutzer suchen"
                        @update="updateNewAssignedUser"
                        dense
                        outlined
                        dark
                        class="mb-2"></user-search>
                      <v-btn block small color="primary" @click="submitAssignment" :disabled="!newAssignedUser">Zuweisen</v-btn>
                    </div>
                  </v-expand-transition>

                  <div class="d-flex flex-wrap">
                    <v-chip
                      v-for="(u, i) in currentTodo?.assignedUsers"
                      :key="i"
                      class="mr-2 mb-2"
                      close
                      dark
                      @click:close="removeUser(u._id)"
                      small
                      outlined>
                      <v-avatar left color="grey darken-3" class="white--text">{{ u.user.vorname[0] }}</v-avatar>
                      {{ u.user.vorname }} {{ u.user.nachname }}
                    </v-chip>
                    <span v-if="!currentTodo?.assignedUsers?.length" class="caption grey--text font-italic">Niemand zugewiesen</span>
                  </div>
                </div>

                <v-divider class="mb-4" dark></v-divider>

                <!-- Attachments -->
                <h3 class="text-subtitle-1 font-weight-bold mb-2 white--text">Anhänge</h3>
                <v-row dense>
                  <v-col cols="6" v-for="(att, idx) in currentTodoAttachments" :key="idx">
                    <v-card
                      outlined
                      class="pa-2 d-flex align-center"
                      color="#2C2C2C"
                      dark
                      @click="att.type === 'image' ? openAttachementDialog(idx) : openAttachment(att)">
                      <v-icon class="mr-2" large color="primary">{{ getAttachmentIcon(att.type) }}</v-icon>
                      <div class="text-truncate caption white--text">{{ att.originalName }}</div>
                      <v-spacer></v-spacer>
                      <v-btn icon x-small color="red" @click.stop="deleteSelectedAttachment(att._id)"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card>
                  </v-col>
                </v-row>

                <div class="d-flex mt-3">
                  <v-btn small outlined dark class="mr-2 flex-grow-1" @click="triggerFileUpload"
                    ><v-icon left small>mdi-paperclip</v-icon>Datei</v-btn
                  >
                  <v-btn small outlined dark class="flex-grow-1" @click="videoLinkDialog = true"><v-icon left small>mdi-video</v-icon>Link</v-btn>
                </div>
                <!-- Hidden File Input -->
                <v-file-input ref="fileInput" v-model="selectedFile" style="display: none" @change="onFileSelected"></v-file-input>
              </div>
            </v-col>

            <!-- Right Column: Comments & Actions -->
            <v-col cols="12" md="7" lg="8" class="fill-height d-flex flex-column pa-0">
              <v-card flat class="fill-height d-flex flex-column" dark color="#1E1E1E">
                <v-card-text class="flex-grow-1 overflow-hidden d-flex flex-column pa-0">
                  <div class="d-flex flex-column fill-height">
                    <!-- Toolbar -->
                    <v-toolbar flat dense color="#2c2c2c" class="flex-shrink-0">
                      <v-toolbar-title class="text-subtitle-1 white--text">Kommentare</v-toolbar-title>
                    </v-toolbar>
                    <div class="flex-grow-1 overflow-y-auto pa-4">
                      <div v-if="currentTodo?.comments?.length === 0" class="text-center grey--text mt-10">Keine Kommentare vorhanden.</div>
                      <div v-for="(comment, index) in currentTodo?.comments" :key="index" class="mb-3 d-flex flex-column">
                        <div class="d-flex align-center mb-1" :class="{ 'justify-end': isCurrentUser(comment.user._id) }">
                          <span class="caption grey--text mr-2" v-if="!isCurrentUser(comment.user._id)"
                            >{{ comment.user.vorname }} {{ comment.user.nachname }}</span
                          >
                          <span class="caption grey--text">{{ formatDate(comment.createdAt) }}</span>
                        </div>
                        <v-card
                          :color="isCurrentUser(comment.user._id) ? 'primary' : '#2C2C2C'"
                          dark
                          class="rounded-lg pa-3 elevation-1"
                          :class="{ 'align-self-end': isCurrentUser(comment.user._id), 'align-self-start': !isCurrentUser(comment.user._id) }"
                          style="max-width: 80%">
                          <div class="text-body-2 white--text">{{ comment.comment }}</div>
                          <v-chip x-small v-if="comment.marketingOnly" color="orange" dark class="mt-1">Marketing Only</v-chip>
                          <div class="text-right mt-1" v-if="comment.status && comment.status !== 'none'">
                            <v-chip x-small outlined dark>{{ comment.status }}</v-chip>
                          </div>
                        </v-card>
                      </div>
                    </div>
                  </div>
                </v-card-text>

                <!-- Action Area -->
                <v-card flat class="pa-4 border-top" color="#1E1E1E" dark>
                  <v-row v-if="currentTodo?.category == 'cl' || currentTodo?.category == 'it'" class="mb-2">
                    <v-col cols="6">
                      <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y min-width="auto" dark>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="currentTodo.plannedDate"
                            label="Planung (Datum)"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense
                            dark></v-text-field>
                        </template>
                        <v-date-picker v-model="currentTodo.plannedDate" @input="dateMenu = false" dark></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" v-if="currentTodo">
                      <v-menu v-model="timeMenu" :close-on-content-click="false" offset-y min-width="auto" dark>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="currentTodo.plannedTime"
                            label="Planung (Zeit)"
                            prepend-icon="mdi-clock"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            dense
                            dark></v-text-field>
                        </template>
                        <v-time-picker v-model="currentTodo.plannedTime" @input="timeMenu = false" format="24hr" dark></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-textarea
                    v-model="newComment"
                    outlined
                    rows="2"
                    label="Schreibe einen Kommentar..."
                    hide-details
                    class="rounded-lg"
                    dark></v-textarea>

                  <div class="d-flex align-center justify-space-between mt-3 flex-wrap">
                    <div class="d-flex align-center flex-wrap mb-2 mb-sm-0">
                      <v-switch v-model="isResolved" label="Erledigen" dense hide-details class="mr-4" dark></v-switch>
                      <v-switch
                        v-if="currentTodo && userService.hasRight('todo_fetchAllMarketing')"
                        v-model="currentTodo.inProgress"
                        @change="updateInProgressStatus"
                        label="In Bearbeitung"
                        dense
                        hide-details
                        dark></v-switch>
                    </div>
                    <v-btn color="primary" @click="submitComment" elevation="0" class="flex-grow-1 flex-sm-grow-0"
                      >Senden <v-icon right small>mdi-send</v-icon></v-btn
                    >
                  </div>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <!-- Attachment View Dialog -->
    <v-dialog v-model="attachementDialog" max-width="900" dark>
      <v-card color="black" dark>
        <v-img
          contain
          :src="currentTodoAttachments[selectedAttachementIndex] ? currentTodoAttachments[selectedAttachementIndex].url : ''"
          max-height="80vh"></v-img>
        <v-card-actions class="justify-center">
          <v-btn text @click="attachementDialog = false">Schliessen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Video Link Dialog -->
    <v-dialog v-model="videoLinkDialog" max-width="400" dark>
      <v-card color="#1E1E1E" dark>
        <v-card-title>Video Link</v-card-title>
        <v-card-text>
          <v-text-field v-model="newVideoLink" label="YouTube Link" outlined dense autofocus dark></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="videoLinkDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="addVideoLink">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Translation Dialog -->
    <v-dialog v-model="translationDialog" max-width="500px" dark>
      <v-card color="#1E1E1E" dark>
        <v-card-title class="headline">Übersetzung (Türkisch)</v-card-title>
        <v-card-text class="body-1 pt-4 white--text">
          {{ translatedDescription }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="translationDialog = false">Schliessen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Parent Selection Dialog -->
    <v-dialog v-model="parentSelectionDialog" max-width="600" dark scrollable>
      <v-card color="#1e1e1e" dark>
        <v-card-title class="headline mb-2" style="text-transform: uppercase">Überkategorie wählen</v-card-title>
        <v-card-subtitle
          ><v-chip small color="primary">Nur im gleichen Studio möglich</v-chip>
          <v-switch
            label="Alle Studios anzeigen"
            v-if="showAllStudioSelect"
            v-model="showAllStudios"
            hide-details
            dense
            dark
            v-bind="attrs"
            v-on="on"
            @change="reloadTodos"></v-switch
        ></v-card-subtitle>
        <v-card-text style="height: 500px">
          <v-text-field
            v-model="parentSearch"
            label="Suchen..."
            outlined
            dense
            dark
            clearable
            class="mb-2"
            prepend-inner-icon="mdi-magnify"></v-text-field>
          <v-treeview
            :items="potentialParentsTree"
            item-key="id"
            item-text="name"
            :search="parentSearch"
            activatable
            @update:active="selectParent"
            hoverable
            dense
            dark
            item-disabled="disabled">
            <template v-slot:prepend="{ item }">
              <v-icon small v-if="item.children && item.children.length" :disabled="item.disabled">mdi-folder</v-icon>
              <v-icon small v-else :disabled="item.disabled">mdi-file-document-outline</v-icon>
            </template>

            <template v-slot:label="{ item }">
              <div class="d-flex align-center" :class="{ 'grey--text': item.disabled }">
                <span class="mr-2">
                  {{ item.title }}
                  <span v-if="item.disabled" class="caption font-italic"> - ({{ item.studioName }}) </span>
                </span>

                <v-chip x-small v-if="item.priority" :color="getPriorityColor(item.priority)" outlined :disabled="item.disabled">
                  {{ mapPriorityName(item.priority) }}
                </v-chip>
                <v-chip x-small v-if="item.resolved" class="ml-1" color="grey" outlined>Erledigt</v-chip>
              </div>
            </template>
          </v-treeview>
          <div v-if="potentialParentsTree.length === 0" class="text-center grey--text mt-4">
            Keine Aufgaben gefunden, die als Überkategorie dienen können.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="parentSelectionDialog = false">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="marketingEventDialog" max-width="600px" dark>
      <v-card color="#1E1E1E" dark>
        <v-card-title class="headline pink--text"><v-icon left color="pink">mdi-calendar-star</v-icon> Kampagnen-Tage & Feiertage</v-card-title>
        <v-card-text>
          <div class="text-subtitle-2 mb-2 white--text">Aktive Kampagnen & Feiertage</div>

          <div v-if="marketingEvents.length === 0" class="text-center grey--text py-4 caption">Noch keine Events vorhanden.</div>

          <v-list dense dark color="#1E1E1E" class="mb-6" v-else>
            <v-list-item v-for="(event, i) in marketingEvents" :key="event._id" class="mb-1 rounded hover-bg" style="border: 1px solid #333">
              <v-list-item-action>
                <v-checkbox v-model="event.isActive" color="pink" @change="toggleMarketingEvent(event)"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title :class="{ 'grey--text text-decoration-line-through': !event.isActive }">{{ event.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ $moment(event.startDate).format("DD.MM.YYYY") }}
                  <span v-if="event.endDate && event.startDate !== event.endDate"> - {{ $moment(event.endDate).format("DD.MM.YYYY") }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="event.isCustom">
                <v-btn icon small color="red" @click="deleteMarketingEvent(event._id, i)"><v-icon small>mdi-delete</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider class="mb-4 border-grey-darken-3"></v-divider>

          <div class="text-subtitle-2 mb-2 white--text">Neues Event hinzufügen</div>
          <v-tabs v-model="eventTab" dark color="pink">
            <v-tab>Aus System-Feiertag</v-tab>
            <v-tab>Eigenes / Mehrtägig</v-tab>
          </v-tabs>

          <v-tabs-items v-model="eventTab" dark style="background: transparent">
            <v-tab-item class="pt-4">
              <v-row dense>
                <v-col cols="4">
                  <v-select
                    v-model="selectedHolidayYear"
                    :items="availableHolidayYears"
                    label="Jahr"
                    outlined
                    dense
                    dark
                    @change="loadHolidayOptionsForYear"></v-select>
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="selectedOfficialHoliday"
                    :items="availableHolidayOptions"
                    item-text="name"
                    return-object
                    label="System-Feiertag suchen..."
                    outlined
                    dense
                    dark
                    :disabled="!holidayOptions.length">
                    <template v-slot:item="{ item }"> {{ item.name }} ({{ $moment(item.startDate).format("DD.MM.YYYY") }}) </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-btn class="mt-2" color="pink" block @click="addOfficialHoliday" :disabled="!selectedOfficialHoliday"
                >Als Kampagnen-Tag hinzufügen</v-btn
              >
            </v-tab-item>

            <v-tab-item class="pt-4">
              <v-text-field v-model="newMarketingEvent.name" label="Event Name (z.B. Black Week)" outlined dense dark></v-text-field>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field v-model="newMarketingEvent.startDate" label="Startdatum" type="date" outlined dense dark></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="newMarketingEvent.endDate" label="Enddatum" type="date" outlined dense dark></v-text-field>
                </v-col>
              </v-row>
              <v-btn color="pink" block @click="addCustomEvent" :disabled="!newMarketingEvent.name || !newMarketingEvent.startDate"
                >Eigenes Event speichern</v-btn
              >
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="marketingEventDialog = false">Schliessen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api"
import userSearch from "@/components/userSearch.vue"
import { mapState } from "vuex"
import userService from "@/services/userService"
import { saveAs } from "file-saver"
import socketService from "@/socketService"

export default {
  name: "toDoListMain",
  components: { userSearch },
  data() {
    return {
      userService,
      selectedHolidayYear: new Date().getFullYear(),
      marketingEvents: [],
      holidayOptions: [], // NEU
      selectedOfficialHoliday: null, // NEU
      eventTab: 0, // NEU
      marketingEventDialog: false,
      newMarketingEvent: { name: "", date: "" },
      isSaving: false,
      // State
      onlyUserTodos: false,
      viewMode: "list",
      activeTab: "techniker",
      sortBy: "priority", // 'priority' | 'date'
      selectedStudio: null,
      showAllStudios: false,
      selectedUserFilter: null, // New User Filter
      userFilterKey: 0,
      expandedParents: {}, // Map<todoId, boolean>
      studios: [],
      currentTodoSubtasks: [], // For Detail View

      translatedDescription: "",

      headers: [
        { text: "Titel", value: "title" },
        { text: "Priorität", value: "priority" },
        { text: "Datum", value: "createdAt" },
        { text: "Studio", value: "studio.name" },
        { text: "Ersteller", value: "createdBy" },
        { text: "Zugewiesen", value: "assignedUsers" },
      ],

      // Search Queries map
      searchQueries: {
        techniker: "",
        marketing: "",
        coo: "",
        cl: "",
        it: "",
        redaktionsplan: "",
        resolved: "",
      },

      // Data Lists
      openTodos: [],
      resolvedTodos: [],

      // Dialogs
      todoDialog: false,
      todoDialogTitle: "",
      detailDialog: false,
      videoLinkDialog: false,
      translationDialog: false,
      attachementDialog: false,

      // Editing / Current Item
      currentTodo: null,
      editedTodo: {
        _id: null,
        title: "",
        description: "",
        priority: "medium",
        studio: null,
        plannedDate: null,
        plannedTime: null,
        category: "techniker",
        subcategory: null,
        startDate: null,
        dueDate: null,
        duration: null,
        parent: null,
        status: "backlog",
      },
      editMode: false,
      formValid: false,

      // Attachments
      currentTodoAttachments: [],
      selectedFile: null,
      selectedAttachementIndex: null,
      newVideoLink: "",

      // Assignment
      createdByUser: null,
      assignedUserKey: 0,
      newAssignedUser: null,
      showAssignment: false,

      // Comments
      newComment: "",
      isResolved: false,
      // isMarketingOnlyComment: false, // Removed

      // Date/Time Pickers
      dateMenu: false,
      timeMenu: false,

      // Static Data
      priorityItems: ["low", "medium", "high"],

      // Marketing Spezifische Daten
      targetAudienceOptions: ["Öffentlich", "Mitglieder", "Mitarbeiter"],
      projectTypeOptions: [
        { main: "Print", subs: ["Briefschaften", "Karten", "Flyer", "Inserat", "Plakat", "Blache", "Beschriftung"] },
        { main: "Digital", subs: ["Banner", "Newsletter", "Pop-Up", "Screen", "Präsentation"] },
        { main: "Social Media", subs: ["Instagram", "LinkedIn", "Facebook", "TikTok"] },
        { main: "Video / Bewegtbild", subs: [] },
        { main: "Sonstiges", subs: [] },
      ],
      // UI State für die komplexe Projektart-Auswahl
      marketingSelectedMainTypes: [],
      marketingSelectedSubTypes: {},

      // Parent Selection
      parentSelectionDialog: false,
      parentSearch: "",

      // Timeline Controls
      timelineStartDate: null, // Custom start date for timeline (null = default: today - 7 days)
      timelineStartDateMenu: {}, // v-menu for date picker
      timelineScale: "day", // 'day' | 'week' | 'month'

      // Studio Visibility Hint
      otherStudioTodoCount: 0, // Count of todos in other studios
    }
  },
  beforeDestroy() {
    socketService.off("todo_updated")
  },
  async created() {
    this.setupSocketListeners()
    if (this.userService.hasRight("marketing_redactionToDos")) {
      this.fetchMarketingEvents()
      this.loadHolidayOptionsForYear()
    }
    let studios = await api.fetchStudios()
    this.studios = studios
      .filter((studio) => studio.code && studio.code !== "ot" && studio.code !== "alibey")
      .map((studio) => {
        return { _id: studio._id, name: studio.name }
      })
    this.selectedStudio = this.userStudio

    // Marketing & Redaktionsplan: standardmässig alle Studios anzeigen
    if (this.activeTab === "marketing" || this.activeTab === "redaktionsplan") {
      if (this.userService.hasRight("todo_fetchAllMarketing")) this.showAllStudios = true
    }

    this.fetchOpenTodos()
  },
  watch: {
    async currentTodo(newVal) {
      // Clean up old URLs
      this.currentTodoAttachments.forEach((att) => {
        if (att.objectUrl) URL.revokeObjectURL(att.objectUrl)
      })
      this.currentTodoAttachments = []

      if (newVal && newVal.attachments) {
        for (let attachment of newVal.attachments) {
          try {
            if (attachment.type === "video") {
              this.currentTodoAttachments.push({ ...attachment, url: attachment.filePath })
            } else if (attachment.type === "image") {
              let base64Url = await api.toDoList.fetchAttachment(attachment.filePath, true)
              this.currentTodoAttachments.push({ ...attachment, url: base64Url })
            } else {
              const blob = await api.toDoList.fetchAttachment(attachment.filePath, false)
              const objectUrl = URL.createObjectURL(blob)
              this.currentTodoAttachments.push({ ...attachment, url: objectUrl, objectUrl: objectUrl })
            }
          } catch (error) {
            console.error("Fehler beim Laden des Anhangs:", error)
          }
        }
      }
      // Legacy images support if needed (omitted for brevity as attachments cover it, but keeping array init)
    },
    activeTab(newVal) {
      // Redaktionsplan: Zeitstrahl als Standardansicht
      if (newVal === "redaktionsplan") {
        this.viewMode = "timeline"
        if (this.userService.hasRight("todo_fetchAllMarketing")) this.showAllStudios = true
        else this.showAllStudios = false
      } else if (newVal === "marketing") {
        if (this.userService.hasRight("todo_fetchAllMarketing")) this.showAllStudios = true
        else this.showAllStudios = false
      }

      if (newVal === "resolved") {
        this.fetchResolvedTodos()
      } else {
        this.fetchOpenTodos()
      }
    },
    viewMode(newVal) {
      if (newVal === "board" && this.resolvedTodos.length === 0) {
        this.fetchResolvedTodos()
      }
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    availableHolidayYears() {
      const currentYear = new Date().getFullYear()
      return [currentYear, currentYear + 1, currentYear + 2, currentYear + 3, currentYear + 4]
    },
    availableHolidayOptions() {
      // 1. Sammle alle IDs der System-Feiertage, die bereits hinzugefügt wurden
      const usedHolidayIds = this.marketingEvents.filter((e) => !e.isCustom && e.holidayRef).map((e) => e.holidayRef)

      // 2. Filtere die Liste aus dem Backend: Zeige nur Feiertage, die noch NICHT genutzt wurden
      return this.holidayOptions.filter((opt) => !usedHolidayIds.includes(opt.holidayId))
    },
    showAllStudioSelect() {
      let isErledigtTab =
        (this.userService.hasRight("todo_fetchAllMarketing") && this.activeTab === "resolved") ||
        (this.userService.hasRight("todo_fetchAlltoDoListItemsTechniker") && this.activeTab === "resolved") ||
        (this.userService.hasRight("coo_fetchAlltoDoListItems") && this.activeTab === "resolved") ||
        (this.userService.hasRight("cl_fetchAlltoDoListItems") && this.activeTab === "resolved") ||
        (this.userService.hasRight("it_fetchAlltoDoListItems") && this.activeTab === "resolved")

      let hasRight =
        (this.userService.hasRight("todo_fetchAllMarketing") && this.activeTab === "marketing") ||
        (this.userService.hasRight("todo_fetchAllMarketing") && this.activeTab === "redaktionsplan") ||
        (this.userService.hasRight("todo_fetchAlltoDoListItemsTechniker") && this.activeTab === "techniker") ||
        (this.userService.hasRight("coo_fetchAlltoDoListItems") && this.activeTab === "coo") ||
        (this.userService.hasRight("cl_fetchAlltoDoListItems") && this.activeTab === "cl") ||
        (this.userService.hasRight("it_fetchAlltoDoListItems") && this.activeTab === "it")

      if (!(isErledigtTab || hasRight)) this.showAllStudios = false

      return hasRight || isErledigtTab
    },
    userStudio() {
      return this.userService.getStudio()?._id || null
    },
    availableCategories() {
      let categories = [
        { text: "Techniker", value: "techniker" },
        { text: "Marketing", value: "marketing" },
      ]
      if (this.userService.hasRight("coo_toDoListItems")) categories.push({ text: "COO", value: "coo" })
      if (this.userService.hasRight("cl_toDoListItems")) categories.push({ text: "CL", value: "cl" })
      if (this.userService.hasRight("it_toDoListItems")) categories.push({ text: "IT", value: "it" })
      if (this.userService.hasRight("marketing_redactionToDos")) categories.push({ text: "Redaktionsplan", value: "redaktionsplan" })
      return categories
    },
    availableUsersForFilter() {
      const users = new Map()
      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      allTodos.forEach((todo) => {
        if (todo.assignedUsers && todo.assignedUsers.length) {
          todo.assignedUsers.forEach((assignment) => {
            if (assignment.user && !users.has(assignment.user._id)) {
              users.set(assignment.user._id, assignment.user)
            }
          })
        }
      })
      return Array.from(users.values())
        .map((u) => ({
          ...u,
          fullname: `${u.vorname} ${u.nachname}`,
        }))
        .sort((a, b) => a.fullname.localeCompare(b.fullname))
    },
    potentialParents() {
      const currentStudioId = this.getStudioId(this.editedTodo.studio)

      return this.openTodos
        .filter((t) => t._id !== this.editedTodo._id && t.category === this.editedTodo.category)
        .map((t) => {
          const itemStudioId = this.getStudioId(t.studio)
          const isDifferentStudio = itemStudioId !== currentStudioId

          return {
            ...t,
            disabled: isDifferentStudio, // Vuetify disabled das Item automatisch
            disabledText: isDifferentStudio ? `(${t.studio?.name || "Anderes Studio"})` : "",
          }
        })
    },
    currentTodoParentTitle() {
      if (!this.currentTodo || !this.currentTodo.parent) return ""
      // Try to find parent in loaded todos
      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      const parentId = this.currentTodo.parent._id || this.currentTodo.parent
      const parent = allTodos.find((t) => t._id === parentId)
      return parent ? parent.title : "Überkategorie"
    },
    sortedITSubcategories() {
      const itSubcategories = [
        // --- Software & Services ---
        { text: "E-Mail / Office 365", value: "Email" },
        { text: "TAC (Mitgliedersoftware)", value: "TAC" },

        // --- Access & Security (Sehr wichtig im Gym) ---
        { text: "Zutrittskontrolle (Drehkreuze/Türen)", value: "AccessControl" },
        { text: "RFID-Leser / Check-In", value: "RFIDReaders" },
        { text: "Kamerasystem (CCTV)", value: "CCTV" },

        // --- Infrastructure & Network ---
        { text: "WLAN & Internet", value: "NetworkWifi" },
        { text: "Netzwerk (Router/Switch/Firewall)", value: "NetworkInfrastructure" },
        { text: "Telefonie (VoIP)", value: "Telephony" },

        // --- Hardware / Endpoints ---
        { text: "PC & Workstations", value: "Workstations" },
        { text: "Drucker & Scanner", value: "Printers" },

        { text: "Musikanlage / Sonos", value: "AudioSystem" },
        { text: "TV / Infoscreens", value: "DigitalSignage" },

        // --- Misc ---
        { text: "Allgemein IT", value: "GeneralIT" },
        { text: "Verkabelung", value: "Cabling" },
      ]

      return itSubcategories.sort((a, b) => a.text.localeCompare(b.text))
    },
    sortedCooSubcategories() {
      const subcategories = [
        { text: "Solarium", value: "Solarium" },
        { text: "Me-Scan", value: "Me-Scan" },
        { text: "Hydrojet", value: "Hydrojet" },
        { text: "Ausdauergeräte", value: "Ausdauergeräte" },
        { text: "Kraftgeräte", value: "Kraftgeräte" },
        { text: "Senso Pro", value: "Senso Pro" },
        { text: "Milon", value: "Milon" },
        { text: "Stretching", value: "Stretching" },
        { text: "Plate Loaded", value: "Plate Loaded" },
        { text: "Kabeltürme", value: "Kabeltürme" },
        { text: "Workout ", value: "Workout " },
        { text: "LH", value: "LH" },
        { text: "KH", value: "KH" },
        { text: "Racks", value: "Racks" },
        { text: "MP", value: "MP" },
        { text: "Functional", value: "Functional" },
        { text: "Group Fitness", value: "Group Fitness" },
        { text: "Wellness", value: "Wellness" },
        { text: "Getränkeanlage", value: "Getränkeanlage" },
        { text: "Power Plate", value: "Power Plate" },
        { text: "Kinderhort", value: "Kinderhort" },
        { text: "Pelvix Power", value: "Pelvix Power" },
        { text: "Shop", value: "Shop" },
        { text: "Abfall", value: "Abfall" },
        { text: "Allgemein", value: "Allgemein" },
        { text: "roody", value: "roody" },
        { text: "TAC", value: "TAC" },
        { text: "Schulungen", value: "Schulungen" },
      ]
      return subcategories.sort((a, b) => a.text.localeCompare(b.text))
    },
    sortedClSubcategories() {
      // Reusing the same list as requested/implied by previous logic, or specific CL ones
      const subcategories = [
        { text: "Solarium", value: "Solarium" },
        { text: "Me-Scan", value: "Me-Scan" },
        { text: "Hydrojet", value: "Hydrojet" },
        { text: "Ausdauergeräte", value: "Ausdauergeräte" },
        { text: "Kraftgeräte", value: "Kraftgeräte" },
        { text: "Senso Pro", value: "Senso Pro" },
        { text: "Milon", value: "Milon" },
        { text: "Stretching", value: "Stretching" },
        { text: "Plate Loaded", value: "Plate Loaded" },
        { text: "Kabeltürme", value: "Kabeltürme" },
        { text: "Workout ", value: "Workout " },
        { text: "LH", value: "LH" },
        { text: "KH", value: "KH" },
        { text: "Racks", value: "Racks" },
        { text: "MP", value: "MP" },
        { text: "Functional", value: "Functional" },
        { text: "Group Fitness", value: "Group Fitness" },
        { text: "Wellness", value: "Wellness" },
        { text: "Getränkeanlage", value: "Getränkeanlage" },
        { text: "Power Plate", value: "Power Plate" },
        { text: "Kinderhort", value: "Kinderhort" },
        { text: "Pelvix Power", value: "Pelvix Power" },
        { text: "Shop", value: "Shop" },
        { text: "Abfall", value: "Abfall" },
        { text: "Allgemein", value: "Allgemein" },
        { text: "roody", value: "roody" },
        { text: "TAC", value: "TAC" },
        { text: "Schulungen", value: "Schulungen" },
      ]
      return subcategories.sort((a, b) => a.text.localeCompare(b.text))
    },
    filteredResolvedTodos() {
      let list = this.resolvedTodos

      // Rights Checks
      if (!this.userService.hasRight("coo_toDoListItems")) list = list.filter((t) => t.category !== "coo")
      if (!this.userService.hasRight("cl_toDoListItems")) list = list.filter((t) => t.category !== "cl")
      if (!this.userService.hasRight("it_toDoListItems")) list = list.filter((t) => t.category !== "it")

      const query = (this.searchQueries["resolved"] || "").toLowerCase()
      if (query) {
        list = list.filter((t) => this.matchesTodo(t, query))
      }
      return list
    },
    groupedResolvedTodosFiltered() {
      const groups = {}
      this.filteredResolvedTodos.forEach((todo) => {
        const date = new Date(todo.createdAt)
        const year = date.getFullYear()
        const month = date.getMonth()
        if (!groups[year]) groups[year] = {}
        if (!groups[year][month]) groups[year][month] = { techniker: [], marketing: [], coo: [], cl: [], it: [] }

        if (groups[year][month][todo.category]) {
          groups[year][month][todo.category].push(todo)
        }
      })

      return Object.keys(groups)
        .sort((a, b) => b - a)
        .map((year) => {
          const months = Object.keys(groups[year])
            .sort((a, b) => b - a)
            .map((month) => {
              const grp = groups[year][month]
              const sorter = (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
              return {
                monthName: new Date(year, month).toLocaleString("default", { month: "long" }),
                techniker: grp.techniker.sort(sorter),
                marketing: grp.marketing.sort(sorter),
                coo: grp.coo.sort(sorter),
                cl: grp.cl.sort(sorter),
                it: grp.it.sort(sorter),
                totalCount: grp.techniker.length + grp.marketing.length + grp.coo.length + grp.cl.length + grp.it.length,
              }
            })
            .filter((m) => m.totalCount > 0)
          return { year, months }
        })
        .filter((y) => y.months.length > 0)
    },
    viewIcon() {
      if (this.viewMode === "grid") return "mdi-view-list"
      if (this.viewMode === "board") return "mdi-developer-board"
      if (this.viewMode === "timeline") return "mdi-timeline-clock"
      return "mdi-view-list"
    },
    viewName() {
      if (this.viewMode === "grid") return "Raster"
      if (this.viewMode === "board") return "Board"
      if (this.viewMode === "timeline") return "Zeitstrahl"
      return "Liste"
    },
    timelineStart() {
      if (this.timelineStartDate) {
        return this.$moment(this.timelineStartDate).startOf("day")
      }
      return this.$moment().subtract(7, "days").startOf("day")
    },
    timelineEnd() {
      // Dynamisch: Das späteste Datum (dueDate oder startDate + duration) aller ToDos finden
      let maxDate = this.$moment().add(45, "days")
      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      allTodos.forEach((todo) => {
        if (todo.dueDate) {
          const d = this.$moment(todo.dueDate)
          if (d.isAfter(maxDate)) maxDate = d
        }
        if (todo.startDate && todo.duration) {
          const d = this.$moment(todo.startDate).add(todo.duration, "hours")
          if (d.isAfter(maxDate)) maxDate = d
        }
      })
      return maxDate.add(7, "days").endOf("day")
    },
    timelineDays() {
      let days = []
      let curr = this.timelineStart.clone()
      let end = this.timelineEnd

      if (this.timelineScale === "week") {
        // Wochen-Modus: Jede Woche eine Spalte
        curr = curr.startOf("isoWeek")
        while (curr.isBefore(end)) {
          days.push(curr.clone())
          curr.add(1, "week")
        }
      } else if (this.timelineScale === "month") {
        // Monats-Modus: Jeder Monat eine Spalte
        curr = curr.startOf("month")
        while (curr.isBefore(end)) {
          days.push(curr.clone())
          curr.add(1, "month")
        }
      } else {
        // Tag-Modus (Standard)
        while (curr.isBefore(end)) {
          days.push(curr.clone())
          curr.add(1, "days")
        }
      }
      return days
    },
    timelineColumnWidth() {
      if (this.timelineScale === "week") return 60
      if (this.timelineScale === "month") return 120
      return 40
    },
    timelineMonths() {
      // Berechne Monate mit ihren Spaltenbreiten für die Monatsleiste
      if (this.timelineScale === "month") return [] // Bei Monatsansicht nicht nötig
      const months = []
      let currentMonth = null
      let currentCount = 0
      const colWidth = this.timelineColumnWidth

      this.timelineDays.forEach((day) => {
        const monthKey = day.format("YYYY-MM")
        if (monthKey !== currentMonth) {
          if (currentMonth) {
            months.push({
              key: currentMonth,
              label: this.$moment(currentMonth, "YYYY-MM").format("MMMM YYYY"),
              width: currentCount * colWidth,
            })
          }
          currentMonth = monthKey
          currentCount = 1
        } else {
          currentCount++
        }
      })
      // Letzten Monat hinzufügen
      if (currentMonth) {
        months.push({
          key: currentMonth,
          label: this.$moment(currentMonth, "YYYY-MM").format("MMMM YYYY"),
          width: currentCount * colWidth,
        })
      }
      return months
    },
    editedTodoParentTitle() {
      if (!this.editedTodo || !this.editedTodo.parent) return ""
      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      const parentId = this.editedTodo.parent._id || this.editedTodo.parent
      const parent = allTodos.find((t) => t._id === parentId)
      return parent ? parent.title : "Unbekannt"
    },
    potentialParentsTree() {
      const currentStudioId = this.getStudioId(this.editedTodo.studio)

      let candidates = this.openTodos.filter((t) => t.category === this.editedTodo.category)

      if (this.editedTodo._id) {
        candidates = candidates.filter((t) => t._id !== this.editedTodo._id)
      }

      const map = {}
      // Hier fügen wir die disabled Logik hinzu
      candidates.forEach((t) => {
        const itemStudioId = this.getStudioId(t.studio)
        const isDifferentStudio = itemStudioId !== currentStudioId

        map[t._id] = {
          ...t,
          children: [],
          id: t._id,
          name: t.title,
          disabled: isDifferentStudio, // Wichtig für v-treeview
          studioName: t.studio?.name || "",
        }
      })

      const roots = []
      candidates.forEach((t) => {
        const parentId = t.parent && t.parent._id ? t.parent._id : t.parent
        if (parentId && map[parentId]) {
          map[parentId].children.push(map[t._id])
        } else {
          roots.push(map[t._id])
        }
      })

      return roots
    },
  },
  methods: {
    loadHolidayOptionsForYear() {
      api.toDoList
        .fetchMarketingHolidayOptions(this.selectedHolidayYear)
        .then((data) => {
          this.holidayOptions = data
          // Falls das ausgewählte Jahr wechselt, setzen wir die aktuelle Auswahl zurück
          this.selectedOfficialHoliday = null
        })
        .catch(console.error)
    },
    getEventsForDay(day) {
      if (this.activeTab !== "redaktionsplan") return []

      // Definiert den Zeitraum der aktuellen Spalte (Tag, Woche oder Monat)
      const periodStart = day.clone().startOf(this.timelineScale)
      const periodEnd = day.clone().endOf(this.timelineScale)

      return this.marketingEvents.filter((e) => {
        if (!e.isActive) return false

        const eventStart = this.$moment(e.startDate).startOf("day")
        const eventEnd = this.$moment(e.endDate || e.startDate).endOf("day")

        // Prüfen, ob sich das Event mit dieser Kalender-Spalte überschneidet
        return eventStart.isSameOrBefore(periodEnd) && eventEnd.isSameOrAfter(periodStart)
      })
    },
    addOfficialHoliday() {
      const payload = {
        name: this.selectedOfficialHoliday.name,
        startDate: this.selectedOfficialHoliday.startDate,
        endDate: this.selectedOfficialHoliday.endDate,
        holidayRef: this.selectedOfficialHoliday.holidayId,
      }
      api.toDoList.createMarketingEvent(payload).then(() => {
        this.fetchMarketingEvents()
        this.selectedOfficialHoliday = null // Formular leeren
        this.$toast.success("Feiertag hinzugefügt")
      })
    },
    addCustomEvent() {
      if (!this.newMarketingEvent.name || !this.newMarketingEvent.startDate) return
      api.toDoList.createMarketingEvent(this.newMarketingEvent).then(() => {
        this.fetchMarketingEvents()
        this.newMarketingEvent = { name: "", startDate: "", endDate: "" } // Formular leeren
        this.$toast.success("Event hinzugefügt")
      })
    },
    fetchMarketingEvents() {
      api.toDoList
        .fetchMarketingEvents()
        .then((data) => {
          this.marketingEvents = data
        })
        .catch(console.error)
    },
    toggleMarketingEvent(event) {
      api.toDoList.updateMarketingEvent(event._id, { isActive: event.isActive }).then(() => {
        this.$toast.success("Status aktualisiert")
      })
    },
    addMarketingEvent() {
      if (!this.newMarketingEvent.name || !this.newMarketingEvent.date) return
      api.toDoList.createMarketingEvent(this.newMarketingEvent).then((res) => {
        this.marketingEvents.push(res)
        this.newMarketingEvent = { name: "", date: "" }
        this.$toast.success("Event hinzugefügt")
      })
    },
    deleteMarketingEvent(id, index) {
      if (confirm("Event löschen?")) {
        api.toDoList.deleteMarketingEvent(id).then(() => {
          this.marketingEvents.splice(index, 1)
        })
      }
    },
    changeStudioSelectToDo() {
      if (this.showAllStudios) return
      this.showAllStudios = true
      this.reloadTodos()
    },
    getStudioId(studioOrId) {
      if (!studioOrId) return null
      return typeof studioOrId === "object" ? studioOrId._id : studioOrId
    },
    setupSocketListeners() {
      socketService.off("todo_updated")
      socketService.on("todo_updated", (updatedTodo) => {
        this.$toast.info(`ToDo "${updatedTodo.title}" wurde aktualisiert!`)
        this.openTodos = this.openTodos.filter((todo) => todo._id !== updatedTodo._id)
        this.resolvedTodos = this.resolvedTodos.filter((todo) => todo._id !== updatedTodo._id)

        if (updatedTodo.resolved) {
          this.resolvedTodos.unshift(updatedTodo)
        } else {
          let priorityValue = this.getPriorityValue(updatedTodo.priority)
          this.openTodos.unshift({ ...updatedTodo, priorityValue })
        }
        if (this.currentTodo && this.currentTodo._id === updatedTodo._id) {
          this.currentTodo = updatedTodo
        }
      })
    },
    getPriorityValue(priority) {
      if (priority === "high") return 3
      if (priority === "medium") return 2
      return 1
    },
    shouldShowCategory(cat) {
      if (cat === "coo" && !this.userService.hasRight("coo_toDoListItems")) return false
      if (cat === "cl" && !this.userService.hasRight("cl_toDoListItems")) return false
      if (cat === "it" && !this.userService.hasRight("it_toDoListItems")) return false
      if (cat === "redaktionsplan" && !this.userService.hasRight("marketing_redactionToDos")) return false
      return true
    },
    getMyTodos(category) {
      const userId = this.userService.getUser()?._id
      if (!userId) return []
      return this.openTodos.filter((t) => t.category === category && t.assignedUsers && t.assignedUsers.some((u) => u.user && u.user._id === userId))
    },

    setSort(type) {
      this.sortBy = type
    },
    toggleExpand(id) {
      this.$set(this.expandedParents, id, !this.expandedParents[id])
    },
    toggleOnlyUserTodos() {
      this.onlyUserTodos = !this.onlyUserTodos
      this.reloadTodos()
    },
    matchesTodo(todo, query) {
      if (todo.title?.toLowerCase().includes(query)) return true
      if (todo.description?.toLowerCase().includes(query)) return true
      if (todo.studio?.name?.toLowerCase().includes(query)) return true
      if (todo.createdBy?.vorname?.toLowerCase().includes(query)) return true
      if (todo.createdBy?.nachname?.toLowerCase().includes(query)) return true
      return false
    },
    getPriorityColor(priority) {
      if (priority === "high") return "red"
      if (priority === "medium") return "orange"
      return "green"
    },
    getPriorityColorHex(priority) {
      if (priority === "high") return "#F44336" // Red 500
      if (priority === "medium") return "#FF9800" // Orange 500
      return "#4CAF50" // Green 500
    },
    mapPriorityName(priority) {
      if (priority === "high") return "Hoch"
      if (priority === "medium") return "Mittel"
      return "Niedrig"
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD.MM.YY HH:mm") : ""
    },
    fetchOpenTodos() {
      // Logic adjustment for "Show All Studios"
      let studioFilter = this.selectedStudio
      if (this.showAllStudios) studioFilter = null

      api.toDoList
        .fetchAll({ status: "open", studio: studioFilter, onlyUserTodos: this.onlyUserTodos })
        .then((data) => {
          this.openTodos = data.map((todo) => ({ ...todo, priorityValue: this.getPriorityValue(todo.priority) }))

          if (this.currentTodo && this.currentTodo._id) {
            const found = this.openTodos.find((t) => t._id === this.currentTodo._id)
            if (found) this.currentTodo = found
          }

          // Studio-Hinweis: Berechne Anzahl ToDos in anderen Studios

          if (!this.showAllStudios && this.selectedStudio) {
            api.toDoList
              .fetchAll({ status: "open", studio: null, onlyUserTodos: this.onlyUserTodos })
              .then((allData) => {
                // 1. Zähle ALLE offenen ToDos der AKTUELLEN Kategorie über alle Studios
                const totalInActiveTab = allData.filter((e) => e.category === this.activeTab).length

                // 2. Zähle ALLE offenen ToDos der AKTUELLEN Kategorie im AKTUELLEN Studio
                const currentStudioInActiveTab = this.openTodos.filter((e) => e.category === this.activeTab).length

                // 3. Differenz = ToDos in anderen Studios
                this.otherStudioTodoCount = totalInActiveTab - currentStudioInActiveTab

                // Sicherungsnetz, falls es doch mal ins Minus rutscht
                if (this.otherStudioTodoCount < 0) this.otherStudioTodoCount = 0
              })
              .catch(() => {
                this.otherStudioTodoCount = 0
              })
          } else {
            this.otherStudioTodoCount = 0
          }
        })
        .catch(console.error)
    },
    fetchResolvedTodos() {
      let studioFilter = this.selectedStudio
      if (this.showAllStudios) studioFilter = null

      api.toDoList
        .fetchAll({ status: "resolved", studio: studioFilter, onlyUserTodos: this.onlyUserTodos })
        .then((data) => {
          this.resolvedTodos = data.map((todo) => ({ ...todo, priorityValue: this.getPriorityValue(todo.priority) }))
          if (this.currentTodo && this.currentTodo._id) {
            const found = this.resolvedTodos.find((t) => t._id === this.currentTodo._id)
            if (found) this.currentTodo = found
          }
        })
        .catch(console.error)
    },
    reloadTodos() {
      if (this.activeTab === "resolved") this.fetchResolvedTodos()
      else this.fetchOpenTodos()
    },
    // Actions
    openParentSelectionDialog() {
      this.parentSelectionDialog = true
    },
    selectParent(items) {
      if (items && items.length > 0) {
        this.editedTodo.parent = items[0]
        this.parentSelectionDialog = false
      }
    },
    openCreateDialog() {
      this.todoDialogTitle = "Neuer ToDo Eintrag"
      this.createdByUser = null
      this.assignedUserKey++
      this.editedTodo = {
        _id: null,
        title: "",
        studio: this.userStudio,
        createdBy: null,
        description: "",
        priority: "low",
        category: this.activeTab !== "resolved" ? this.activeTab : "techniker",
        subcategory: null,
        plannedDate: null,
        plannedTime: null,
        startDate: null,
        dueDate: null,
        duration: null,
        parent: null,
        status: "backlog",
        marketingDetails: {
          contactInfo: "",
          projectTypes: [],
          targetAudience: [],
          hasText: false,
          hasImages: false,
          contentNotes: "",
          formatNotes: "",
          printRun: "",
        },
      }
      this.marketingSelectedMainTypes = []
      this.marketingSelectedSubTypes = {}
      this.todoDialog = true
    },
    closeTodoDialog() {
      this.todoDialog = false
    },
    saveTodo() {
      // Validierung VOR dem Ladezustand
      if (this.editedTodo.title.trim() === "") return this.$toast.error("Titel ist Pflicht")
      if (this.editedTodo.description.trim() === "") return this.$toast.error("Beschreibung ist Pflicht")
      // if (this.editedTodo.description.length < 30) return this.$toast.error("Beschreibung mind. 30 Zeichen")

      // Priority Auto-Low Logic
      if (
        (this.editedTodo.category === "marketing" && !userService.hasRight("todo_fetchAllMarketing") && this.editedTodo.priority !== "low") ||
        (this.editedTodo.category === "cl" && !userService.hasRight("cl_toDoListItems") && this.editedTodo.priority !== "low") ||
        (this.editedTodo.category === "it" && !userService.hasRight("it_toDoListItems") && this.editedTodo.priority !== "low")
      ) {
        this.editedTodo.priority = "low"
        this.$toast.info("Priorität wird vom Fachbereich gesetzt")
      }

      // Ladezustand aktivieren
      this.isSaving = true

      if (this.editedTodo.category === "marketing") {
        this.editedTodo.marketingDetails.projectTypes = this.marketingSelectedMainTypes.map((main) => {
          return {
            mainType: main,
            subTypes: this.marketingSelectedSubTypes[main] || [],
          }
        })
      }

      if (this.editedTodo._id) {
        // Update Logic (falls Dialog für Edit genutzt wird)
        api.toDoList
          .update(this.editedTodo._id, this.editedTodo)
          .then(() => {
            this.reloadTodos()
            this.todoDialog = false
          })
          .catch(console.error)
          .finally(() => {
            this.isSaving = false // Reset
          })
      } else {
        // Create Logic
        if (!this.createdByUser) {
          this.isSaving = false // Reset falls Validierung hier fehlschlägt
          return this.$toast.error("Ersteller wählen")
        }
        this.editedTodo.createdBy = this.createdByUser

        api.toDoList
          .create(this.editedTodo)
          .then((e) => {
            if (this.editedTodo.category === "marketing") {
              this.$toast.info("Bitte prüfe kurz, ob alle Infos im ToDo enthalten sind. Füge bei Bedarf noch relevante Anhänge hinzu.", {
                timeout: 8000,
              })
            }
            if (this.editedTodo.studio !== this.selectedStudio) {
              this.selectedStudio = this.editedTodo.studio
            }
            this.activeTab = this.editedTodo.category
            this.reloadTodos()
            this.openDetailDialog(e)
            this.todoDialog = false
          })
          .catch(console.error)
          .finally(() => {
            this.isSaving = false // Reset
          })
      }
    },
    async openDetailDialogById(id) {
      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      const todo = allTodos.find((t) => t._id === id)
      if (todo) {
        this.openDetailDialog(todo)
      } else {
        // Fetch if not found locally? Or just ignore
      }
    },
    openDetailDialog(item) {
      if (!item) return
      this.currentTodo = {
        plannedDate: item.plannedDate || null,
        plannedTime: item.plannedTime || null,
        ...item,
        startDate: item.startDate ? item.startDate.substr(0, 10) : null,
        dueDate: item.dueDate ? item.dueDate.substr(0, 10) : null,
        duration: item.duration || null,
        parent: item.parent?._id || item.parent || null,
        status: item.status || (item.resolved ? "done" : item.inProgress ? "in_progress" : "backlog"),
        marketingDetails: item.marketingDetails ? JSON.parse(JSON.stringify(item.marketingDetails)) : null,
      }

      // Populate Subtasks (Fetch from server to ensure we get ALL, including resolved ones)
      // We optimistically populate from loaded todos first
      const allCategoryTodos = [...this.openTodos, ...this.resolvedTodos].filter((t) => t.category === this.currentTodo.category)
      this.currentTodoSubtasks = allCategoryTodos.filter((child) => child.parent === item._id || child.parent?._id === item._id)

      // Async fetch to get everything (especially if we are in Open tab and don't have resolved subtasks)
      api.toDoList
        .fetchAll({ parent: item._id, status: "all" })
        .then((subtasks) => {
          this.currentTodoSubtasks = subtasks
        })
        .catch((err) => console.error("Failed to fetch subtasks", err))

      this.editMode = false
      this.newComment = ""
      this.newVideoLink = ""
      this.showAssignment = false
      this.isResolved = item.resolved
      this.detailDialog = true
    },
    closeDetailDialog() {
      this.detailDialog = false
    },

    toggleEditMode() {
      this.editMode = !this.editMode
      if (this.editMode && this.currentTodo) {
        // Erstelle eine tiefe Kopie
        this.editedTodo = JSON.parse(JSON.stringify(this.currentTodo))
        this.editedTodo.studio = this.currentTodo.studio?._id || this.currentTodo.studio

        // FIX: Sicherstellen, dass marketingDetails existiert, falls es ein Marketing-ToDo ist
        if (this.editedTodo.category === "marketing" && !this.editedTodo.marketingDetails) {
          this.$set(this.editedTodo, "marketingDetails", {
            contactInfo: "",
            projectTypes: [],
            targetAudience: [],
            hasText: false,
            hasImages: false,
            contentNotes: "",
            formatNotes: "",
            printRun: "",
          })
        }

        if (this.editedTodo.category === "marketing") {
          // Main-Types extrahieren (jetzt sicher, da Objekt oben initialisiert wurde)
          this.marketingSelectedMainTypes = this.editedTodo.marketingDetails.projectTypes?.map((pt) => pt.mainType) || []

          // Sub-Types wieder ins Hilfsobjekt mappen
          this.marketingSelectedSubTypes = {}
          this.editedTodo.marketingDetails.projectTypes?.forEach((pt) => {
            this.$set(this.marketingSelectedSubTypes, pt.mainType, pt.subTypes || [])
          })
        }
      }
    },
    saveEdit() {
      this.isSaving = true // Start Loading
      // WICHTIG: Die gemappten Projektarten für Marketing aufbereiten
      if (this.editedTodo.category === "marketing" && this.editedTodo.marketingDetails) {
        this.editedTodo.marketingDetails.projectTypes = this.marketingSelectedMainTypes.map((main) => {
          return {
            mainType: main,
            subTypes: this.marketingSelectedSubTypes[main] || [],
          }
        })
      }
      const payload = {
        title: this.editedTodo.title,
        description: this.editedTodo.description,
        priority: this.editedTodo.priority,
        studio: this.editedTodo.studio,
        category: this.editedTodo.category,
        subcategory: this.editedTodo.subcategory,
        startDate: this.editedTodo.startDate,
        dueDate: this.editedTodo.dueDate,
        duration: this.editedTodo.duration,
        parent: this.editedTodo.parent,
        status: this.editedTodo.status,
        marketingDetails: this.editedTodo.marketingDetails,
      }

      api.toDoList
        .update(this.currentTodo._id, payload)
        .then(() => {
          this.editMode = false
          this.reloadTodos()
        })
        .catch(console.error)
        .finally(() => {
          this.isSaving = false // Stop Loading
        })
    },
    deleteCurrentTodo() {
      if (confirm("Wirklich löschen?")) {
        api.toDoList
          .delete(this.currentTodo._id)
          .then(() => {
            this.closeDetailDialog()
            this.reloadTodos()
          })
          .catch(console.error)
      }
    },
    submitComment() {
      const payload = {
        comment: this.newComment,
        plannedDate: this.currentTodo.plannedDate,
        plannedTime: this.currentTodo.plannedTime,
        status: this.isResolved ? "resolved" : "opened",
        marketingOnly: this.isMarketingOnlyComment,
      }
      api.toDoList
        .addComment(this.currentTodo._id, payload)
        .then(() => {
          this.newComment = ""
          this.reloadTodos()
          this.$toast.success("Kommentar gespeichert")
        })
        .catch(console.error)
    },
    updateInProgressStatus() {
      api.toDoList
        .update(this.currentTodo._id, { inProgress: this.currentTodo.inProgress })
        .then(() => {
          this.reloadTodos()
        })
        .catch(() => (this.currentTodo.inProgress = !this.currentTodo.inProgress))
    },
    // Assignment
    updateCreatedByUser(u) {
      this.createdByUser = u
    },
    updateNewAssignedUser(u) {
      this.newAssignedUser = u
    },
    updateSelectedUserFilter(u) {
      this.selectedUserFilter = u
      // No need to reload from server if we filter locally, but if we wanted server filter we would call reloadTodos()
      // Local filter is instantaneous
    },
    toggleAssignment() {
      this.showAssignment = !this.showAssignment
    },
    submitAssignment() {
      api.toDoList
        .assign(this.currentTodo._id, { assignment: { user: this.newAssignedUser, rights: "manage" } })
        .then(() => {
          this.newAssignedUser = null
          this.assignedUserKey++
          this.showAssignment = false
          this.reloadTodos()
        })
        .catch(console.error)
    },
    removeUser(id) {
      api.toDoList
        .removeAssignment(this.currentTodo._id, id)
        .then(() => {
          this.currentTodo.assignedUsers = this.currentTodo.assignedUsers.filter((u) => u._id !== id)
          this.reloadTodos()
        })
        .catch(console.error)
    },
    // Attachments & Utils
    copyTextToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => this.$toast.success("Kopiert!"))
    },
    async translateTitle() {
      if (!this.currentTodo?.title) return
      const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(this.currentTodo.title)}&langpair=de|tr`
      try {
        const res = await fetch(url)
        const data = await res.json()
        if (data?.responseData) {
          this.translatedDescription = data.responseData.translatedText
          this.translationDialog = true
        }
      } catch (e) {
        this.$toast.error("Übersetzung fehlgeschlagen")
      }
    },
    async translateText() {
      if (!this.currentTodo?.description) return
      const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(this.currentTodo.description)}&langpair=de|tr`
      try {
        const res = await fetch(url)
        const data = await res.json()
        if (data?.responseData) {
          this.translatedDescription = data.responseData.translatedText
          this.translationDialog = true
        }
      } catch (e) {
        this.$toast.error("Übersetzung fehlgeschlagen")
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.$el.querySelector("input").click()
    },
    onFileSelected(file) {
      if (!file) return
      const fd = new FormData()
      fd.append("file", file)
      api.toDoList
        .uploadAttachment(fd, this.currentTodo._id)
        .then(() => {
          this.$toast.success("Hochgeladen")
          this.reloadTodos()
        })
        .catch((e) => this.$toast.error("Upload Fehler"))
      this.selectedFile = null
    },
    openAttachment(att) {
      api.toDoList
        .fetchAttachment(att.filePath, false)
        .then((blob) => saveAs(blob, att.originalName))
        .catch(console.error)
    },
    getAttachmentIcon(type) {
      if (type === "pdf") return "mdi-file-pdf-box"
      if (type === "video") return "mdi-youtube"
      return "mdi-file-document"
    },
    deleteSelectedAttachment(id) {
      if (confirm("Anhang löschen?")) {
        api.toDoList.deleteAttachment({ _id: this.currentTodo._id, attachmentId: id }).then(() => this.reloadTodos())
      }
    },
    openAttachementDialog(idx) {
      this.selectedAttachementIndex = idx
      this.attachementDialog = true
    },
    addVideoLink() {
      if (!this.newVideoLink) return
      api.toDoList.addVideoLink(this.currentTodo._id, { videoLink: this.newVideoLink }).then(() => {
        this.videoLinkDialog = false
        this.newVideoLink = ""
        this.reloadTodos()
      })
    },
    isCurrentUser(id) {
      return this.userService.getUser()?._id === id
    },
    canEditPriority() {
      // Simplified check
      if (this.editedTodo.category === "marketing" && !this.userService.hasRight("todo_fetchAllMarketing")) return false
      if (this.editedTodo.category === "cl" && !this.userService.hasRight("cl_toDoListItems")) return false
      if (this.editedTodo.category === "it" && !this.userService.hasRight("it_toDoListItems")) return false
      return true
    },
    isCategoryDisabled(cat) {
      if (cat === "coo" && !this.userService.hasRight("coo_toDoListItems")) return true
      if (cat === "cl" && !this.userService.hasRight("cl_toDoListItems")) return true
      if (cat === "it" && !this.userService.hasRight("it_toDoListItems")) return true
      return false
    },
    getBoardItems(category, status) {
      let items = []
      if (status === "done") {
        // We filter locally from resolvedTodos
        items = this.resolvedTodos.filter((t) => t.category === category)
      } else {
        let open = this.openTodos.filter((t) => t.category === category)
        if (status === "in_progress") {
          items = open.filter((t) => t.status === "in_progress" || t.inProgress)
        } else {
          // backlog (default)
          items = open.filter((t) => t.status === "backlog" || (!t.status && !t.inProgress))
        }
      }
      // Filter out children (tasks with parent) for Board View
      items = items.filter((t) => !t.parent)

      // Calculate subtask counts (from original 'open' list or combined?)
      // We want to know how many children this parent has in total (backlog/inprogress/done)
      // Actually, we should probably count from 'all' visible todos for this category
      const allCategoryTodos = [...this.openTodos, ...this.resolvedTodos].filter((t) => t.category === category)

      items = items.map((t) => {
        const count = allCategoryTodos.filter((child) => child.parent === t._id || child.parent?._id === t._id).length
        return { ...t, subtaskCount: count }
      })

      // Search Filter
      const query = (this.searchQueries[category] || "").toLowerCase()
      if (query) {
        items = items.filter((t) => this.matchesTodo(t, query))
      }

      // User Filter
      if (this.selectedUserFilter) {
        items = items.filter((t) => t.assignedUsers.some((u) => u.user._id === this.selectedUserFilter._id))
      }
      return items
    },
    getTimelineBarStyle(item) {
      let start = item.startDate ? this.$moment(item.startDate) : this.$moment(item.createdAt)
      let end = item.dueDate ? this.$moment(item.dueDate) : item.duration ? start.clone().add(item.duration, "hours") : start.clone().add(2, "hours")

      // Ensure valid range
      if (end.isBefore(start)) end = start.clone().add(2, "hours")

      let viewStart = this.timelineStart
      let colWidth = this.timelineColumnWidth

      let offsetDays, durationDays

      if (this.timelineScale === "week") {
        offsetDays = start.diff(viewStart, "weeks", true)
        durationDays = end.diff(start, "weeks", true)
        if (durationDays < 0.1) durationDays = 0.1
      } else if (this.timelineScale === "month") {
        offsetDays = start.diff(viewStart, "months", true)
        durationDays = end.diff(start, "months", true)
        if (durationDays < 0.05) durationDays = 0.05
      } else {
        offsetDays = start.diff(viewStart, "days", true)
        durationDays = end.diff(start, "days", true)
        if (durationDays < 0.1) durationDays = 0.1
      }

      let left = offsetDays * colWidth
      let width = durationDays * colWidth

      // Bounds checking
      if (left < 0) {
        width += left
        left = 0
      }

      return {
        left: left + "px",
        width: width + "px",
        position: "absolute",
        top: "8px",
        height: "24px",
        opacity: "0.9",
        fontSize: "10px",
      }
    },
    getTimelineBarColor(item) {
      if (item.isMarketingEvent) return "pink darken-2"
      if (item.resolved) return "grey darken-1"
      if (item.status === "in_progress" || item.inProgress) return "blue darken-2"
      if (item.priority === "high") return "red darken-2"
      if (item.priority === "medium") return "orange darken-3"
      return "green darken-2"
    },
    getSortedTodos(category, isTimeline = false) {
      let list = this.openTodos.filter((t) => t.category === category)

      // Search Filter
      const query = (this.searchQueries[category] || "").toLowerCase()
      if (query) {
        list = list.filter((t) => this.matchesTodo(t, query))
      }

      // User Filter
      if (this.selectedUserFilter) {
        list = list.filter((t) => t.assignedUsers.some((u) => u.user._id === this.selectedUserFilter._id))
      }

      // Sorting
      // WICHTIG: Erst sortieren, damit die Reihenfolge innerhalb der Gruppen beim Baum-Aufbau stimmt
      if (isTimeline) {
        // Chronologisch aufsteigend für den Zeitstrahl
        list.sort((a, b) => {
          const aStart = a.startDate ? new Date(a.startDate) : new Date(a.createdAt)
          const bStart = b.startDate ? new Date(b.startDate) : new Date(b.createdAt)
          return aStart - bStart
        })
      } else if (this.sortBy === "priority") {
        list.sort((a, b) => {
          if (b.priorityValue !== a.priorityValue) return b.priorityValue - a.priorityValue
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
      } else {
        list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      }

      // Hierarchy Flattening
      const map = {}
      list.forEach((t) => (map[t._id] = { ...t, children: [], hasChildren: false }))

      const roots = []
      list.forEach((t) => {
        const parentId = t.parent && t.parent._id ? t.parent._id : t.parent

        if (parentId && map[parentId]) {
          map[parentId].children.push(map[t._id])
          map[parentId].hasChildren = true
        } else {
          roots.push(map[t._id])
        }
      })

      // Recursive flatten
      const flatten = (nodes, level = 0) => {
        let res = []
        nodes.forEach((node) => {
          node.level = level
          res.push(node)

          if (node.children?.length) {
            if (this.viewMode === "grid" || this.expandedParents[node._id]) {
              res.push(...flatten(node.children, level + 1))
            }
          }
        })
        return res
      }

      return flatten(roots)
    },

    getTimelineItems(category) {
      // Keine Marketing-Events mehr hier reinmischen! Einfach nur die ToDos laden.
      return this.getSortedTodos(category, true)
    },
    onDragStart(event, item) {
      event.dataTransfer.dropEffect = "move"
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("todoId", item._id)
    },
    async onDrop(event, status) {
      const todoId = event.dataTransfer.getData("todoId")
      if (!todoId) return

      const allTodos = [...this.openTodos, ...this.resolvedTodos]
      const todo = allTodos.find((t) => t._id === todoId)

      if (!todo) return

      // Update status
      let updates = { _id: todo._id }

      if (status === "backlog") {
        updates.resolved = false
        updates.inProgress = false
        updates.status = "backlog"
      } else if (status === "in_progress") {
        updates.resolved = false
        updates.inProgress = true
        updates.status = "in_progress"
      } else if (status === "done") {
        updates.resolved = true
        updates.inProgress = false
        updates.status = "done"
      }

      // Optimistic update
      // We should reload to be safe or update locally
      // Let's call saveTodo logic but simplified or use saveEdit directly if adapted.
      // Actually saveEdit expects this.editedTodo.
      // We can call api directly.

      try {
        // Fix: Pass ID as first argument
        await api.toDoList.update(updates._id, updates)
        this.reloadTodos()
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>

<style scoped>
.text-truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-truncate-3-lines {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hover-bg:hover {
  background-color: #2c2c2c !important;
}

/* Sichtbare Scrollbar für Zeitstrahl und Tabellenansicht */
.timeline-scrollable::-webkit-scrollbar,
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.timeline-scrollable::-webkit-scrollbar-track,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #2c2c2c;
}
.timeline-scrollable::-webkit-scrollbar-thumb,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 5px;
}
.timeline-scrollable::-webkit-scrollbar-thumb:hover,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.timeline-scrollable {
  /* ... deine bestehenden Scrollbar-Styles bleiben hier ... */

  /* NEU: Höhe begrenzen, damit der Container intern scrollt */
  max-height: calc(100vh - 260px);
}

/* Scrollbar auch für Firefox */
.timeline-scrollable,
::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #666 #2c2c2c;
}

::v-deep .v-slide-group__prev {
  display: none !important;
}

::v-deep .v-toolbar__content {
  width: 100%;
}

.todo-title-truncate {
  display: block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .todo-title-truncate {
    max-width: 160px;
  }
}
</style>
